export const MOCK_LOURMEL = {
    data: {
        idPanier: '66eb2580294f690913fb781e',
        techno: 'FTTH',
        address: {
            codePostal: '75015',
            voie: 'RUE DE LOURMEL',
            commune: 'PARIS 15',
            numeroVoie: '75',
            inlineSplit: ['75  RUE DE LOURMEL', '75015 PARIS 15'],
            inline: '75  RUE DE LOURMEL 75015 PARIS 15',
        },
        technicalAddress: {
            zipCode: '75015',
            city: {
                label: 'PARIS 15',
                INSEECode: '75115',
            },
            street: {
                label: 'RUE DE LOURMEL',
                rivoliCode: '5814',
            },
            streetNumber: {
                number: '75',
                complement: '',
                label: '75',
            },
            hexaKey: '7511522CV9',
            id: '75115LOURL00143',
            imb: 'IMB/75115/C/00BU',
        },
        results: {
            ftth: {
                offers: [
                    '72155222',
                    '72156541',
                    '72156531',
                    '72155705',
                    '72156250',
                    '72156258',
                    '72156252',
                    '72155933',
                    '72156278',
                    '72156220',
                    '72156515',
                    '72155240',
                    '72156234',
                    '72155206',
                    '72156529',
                    '72156547',
                    '72156537',
                    '72155931',
                    '72155441',
                    '72156256',
                    '72156545',
                    '72155667',
                    '72155935',
                    '72156521',
                    '72156248',
                    '72156169',
                    '72156229',
                    '72155917',
                    '72156539',
                    '72156549',
                    '72156517',
                    '72156280',
                    '72155965',
                    '72155382',
                    '72156519',
                    '72156254',
                    '72156241',
                    '72155937',
                    '72156171',
                    '72155919',
                    '72156187',
                    '72156533',
                    '72156535',
                    '72155781',
                    '72155783',
                    '72155958',
                    '72156543',
                ],
                status: true,
                technoType: 'ftth',
                forecast: {
                    name: 'FTTH_DANS_LA_VILLE',
                    date: '2017-01-02',
                    program: 'FTTH',
                },
                buildings: [
                    {
                        building: '_NA_',
                        stairs: [
                            {
                                stair: '_NA_',
                                stages: [
                                    {
                                        floor: '-1',
                                        ptoRequired: false,
                                        ptos: [],
                                    },
                                    {
                                        floor: '0',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-1079-0339',
                                                lineStatus: 'INACTIVE',
                                            },
                                            {
                                                pto: 'FI-6852-0167',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-0006-1358',
                                                lineStatus: 'INACTIVE',
                                            },
                                            {
                                                pto: 'FI-0022-8478',
                                                lineStatus: 'INACTIVE',
                                            },
                                            {
                                                pto: 'FI-0002-9985',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-5048-6414',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                    {
                                        floor: '1',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-0022-8477',
                                                lineStatus: 'INACTIVE',
                                            },
                                            {
                                                pto: 'FI-3236-4398',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-3708-1275',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                    {
                                        floor: '2',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-2270-2186',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-0004-5072',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-0006-5218',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                    {
                                        floor: '3',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-0022-8482',
                                                lineStatus: 'INACTIVE',
                                            },
                                            {
                                                pto: 'FI-1008-2182',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-1237-0291',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-1794-0185',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                    {
                                        floor: '4',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-1401-4494',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-0022-8486',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                    {
                                        floor: '5',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-1338-7792',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-3409-8758',
                                                lineStatus: 'ACTIVE',
                                            },
                                            {
                                                pto: 'FI-8213-7462',
                                                lineStatus: 'INACTIVE',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                        type: 'IMMEUBLE',
                        ptoPresenceRate: 'SATISFAISANT',
                    },
                ],
                shouldBypass: false,
                groupeCategorieRaccoLogement: 'PBO_INTERIEUR',
                housingType: 'IMMEUBLE',
                pmLocationType: 'PMI',
            },
            xdsl: {
                offers: [
                    '72155190',
                    '72155202',
                    '72155212',
                    '72155220',
                    '72155221',
                    '72156174',
                    '72155191',
                    '72155203',
                    '72155213',
                    '72155282',
                    '72155963',
                    '72156181',
                    '72155328',
                    '72155316',
                    '72155440',
                    '72156513',
                    '72155940',
                    '72156233',
                    '72156239',
                    '72155439',
                    '72155970',
                    '72156508',
                ],
                status: true,
                technoType: 'xdsl',
                speedUp: 1,
                speedDown: 12,
            },
            box4g: {
                offers: [],
                status: false,
                technoType: 'box4g',
            },
            box5g: {
                offers: [],
                status: false,
                technoType: 'box5g',
            },
        },
        offers: [
            {
                entity_id: '6594',
                type_id: 'fai',
                sku: '72155206',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                is_highlighted: false,
                exclu_assos: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro + (FTTH) : Internet - TV - Téléphonie ',
                image: '/media/catalog/product/v/i/visuel_ultym_2_10_1.png',
                small_image: '/media/catalog/product/v/i/visuel_ultym_2_10_1.png',
                thumbnail: '/media/catalog/product/v/i/visuel_ultym_2_10_1.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155206',
                label: 'Bbox Pro+ (FTTH) :  Internet - TV - Téléphonie',
                technology: 'FTTH',
                play: '3P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 3P 50,99E ENG 12M',
                equipment: 'internet_box_tv_eole',
                support_stockage: 'Enregistreur 128 Go inclus',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155206-engagement-1',
                short_description: 'Une offre renforcée avec un Wi-Fi<br> étendu et la TV en 4K',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72155269',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_7_2_1.png',
                    'media/catalog/product//v/i/visuel_ultym_2_10_1.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155206-engagement-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155206',
                    },
                    etendu: {
                        href: '/ventes/produits/72155206/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
                option: {
                    id: '72155902',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '2 Gb/s',
                },
            },
            {
                entity_id: '6608',
                type_id: 'fai',
                sku: '72155222',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                image: '/media/catalog/product/e/o/eole_vancouver_3.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_3.png',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_3.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155222',
                label: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                technology: 'FTTH',
                play: '2P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 2P 50,99E ENG 12M',
                equipment: 'internet_box_tv_hdr',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155222-engagement-1-1',
                short_description: 'Essentiel de la fibre',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_fit_1_28_2_2_2.png',
                    'media/catalog/product//b/t/bt_eole-4k-front_00001_2.png',
                    'media/catalog/product//e/o/eole_vancouver_3.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155222-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155222',
                    },
                    etendu: {
                        href: '/ventes/produits/72155222/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
                option: {
                    id: '72155902',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '2 Gb/s',
                },
            },
            {
                entity_id: '9038',
                type_id: 'fai',
                sku: '72155781',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                equipment: 'internet_eole',
                technical_label: 'Bbox Pro Wi-Fi 6 FTTH 2P 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) : Internet - Téléphonie',
                gencode: '72155781',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_3.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_3.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_3.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : Internet - Téléphonie',
                url_key: '72155781-engagement-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Essentiel de la fibre',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_28_2_2_3.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155781-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155781',
                    },
                    etendu: {
                        href: '/ventes/produits/72155781/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '9040',
                type_id: 'fai',
                sku: '72155783',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                support_stockage: 'Enregistreur 128 Go inclus',
                equipment: 'internet_box_tv_hdr',
                technical_label: 'Bbox Pro FTTH 3P 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72155783',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_2.png',
                small_image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_2.png',
                image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_2.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : Internet - TV - Téléphonie',
                url_key: '72155783-engagement-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72156439',
                    '72155390',
                    '72155553',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                    '72155268',
                ],
                medias: ['media/catalog/product//b/b/bbox_ultym_1_9_1_1_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155783-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155783',
                    },
                    etendu: {
                        href: '/ventes/produits/72155783/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '10847',
                type_id: 'fai',
                sku: '72156220',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '0',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                price: 31.99,
                range: 'ss_medium_banque',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv',
                technical_label: 'Série Spéciale Bbox 4K Wifi 6 FTTH 3P',
                unbundling: 'total',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                gencode: '72156220',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/t/bt_polymele.png',
                small_image: '/media/catalog/product/b/t/bt_polymele.png',
                image: '/media/catalog/product/b/t/bt_polymele.png',
                name: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                url_key: '72156220-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation Fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\nInternet garanti avec clé 4G\r\n\r\nTV\r\nPlus de 180 chaînes\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie Fixe\r\nAppels illimités vers les fixes et mobiles en France et vers fixes de plus de 110 pays",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,DEMENAGEMENT',
                network: 'partenaires',
                short_description: 'Série Spéciale Bbox Banque 4K Wifi 6 FTTH 3P 31,99E ENG 12M',
                has_description: false,
                final_price: 31.99,
                ecotax: 0,
                categories: ['FAI-BANQUE-WEB'],
                upSellsProducts: [
                    '72156162',
                    '72155553',
                    '72155687',
                    '72156100',
                    '72156118',
                    '72156201',
                    '72156205',
                    '72154460',
                    '72156206',
                    '72156439',
                    '72156459',
                    '72155638',
                    '72154931',
                    '72154087',
                    '72154560',
                    '72155924',
                    '72155268',
                    '72154085',
                    '72152176',
                    '72155140',
                    '72155641',
                    '72155754',
                    '72155390',
                    '72155642',
                    '72154462',
                    '72154459',
                    '72151539',
                    '72150761',
                    '72153256',
                    '72154082',
                    '72154115',
                    '72154932',
                    '72154731',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3499550359077',
                    '3523930104947',
                    '3760274861789',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-banque-web/72156220-engagement',
                relatedProduct: ['72155144'],
                tax: 0,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156220',
                    },
                    etendu: {
                        href: '/ventes/produits/72156220/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10936',
                type_id: 'fai',
                sku: '72156229',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'small',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '400 Mb/s',
                speed_up: '400 Mb/s',
                equipment: 'internet',
                technical_label: 'Bbox Fit FTTH 2P 29,99E ENG 12M',
                commercial_range: 'Bbox fit',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                gencode: '72156229',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                url_key: '72156229-engagement',
                included_services:
                    "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Fit FTTH 2P 29,99E ENG 12M\r\n',
                has_description: false,
                final_price: 29.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72156439',
                    '72154460',
                    '72154474',
                    '72156162',
                    '72156118',
                    '72156100',
                    '72156190',
                    '72154932',
                    '72154731',
                    '72154424',
                    '72155390',
                    '72153256',
                    '72155563',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_28_2_3_3_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156229-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156229',
                    },
                    etendu: {
                        href: '/ventes/produits/72156229/etendu',
                    },
                },
                promotion: {
                    amount: 14,
                    duration: 6,
                    description: 'Remise Bbox Fit',
                },
                convergence: true,
            },
            {
                entity_id: '10941',
                type_id: 'fai',
                sku: '72156234',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must WIFI 6 FTTH 3P 39,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156234',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156234-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must WIFI 6 FTTH 3P 39,99E ENG 12M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72154731',
                    '72155140',
                    '72152176',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_8_2_2_2_2_6.png',
                    'media/catalog/product//b/b/bbox_must_ftth_1_1_13.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '3523930101946',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156234-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156234',
                    },
                    etendu: {
                        href: '/ventes/produits/72156234/etendu',
                    },
                },
                promotion: {
                    amount: 16,
                    duration: 6,
                    description: 'Remise Bbox Must',
                },
                convergence: true,
            },
            {
                entity_id: '10925',
                type_id: 'fai',
                sku: '72156241',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: 'Bbox Ultym FTTH 3P 49,99E ENG 12M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Ultym FTTH 3P 47,99E ENG 12M',
                gencode: '72156241',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156241',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym FTTH 3P 49,99E ENG 12M',
                has_description: false,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156118',
                    '72155553',
                    '72155787',
                    '72155901',
                    '72156162',
                    '72154489',
                    '72156459',
                    '72156439',
                    '72156190',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72155924',
                    '72154731',
                    '72152176',
                    '72154931',
                    '72154932',
                    '72155268',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_3_5.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156241',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156241',
                    },
                    etendu: {
                        href: '/ventes/produits/72156241/etendu',
                    },
                },
                promotion: {
                    amount: 20,
                    duration: 6,
                    description: 'Remise Bbox Ultym',
                },
                convergence: true,
                option: {
                    id: '72155901',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '1 Gb/s',
                },
            },
            {
                entity_id: '10927',
                type_id: 'fai',
                sku: '72156248',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'sl_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: ' Bbox Ultym Gaming FTTH 3P 49,99E ENG 24M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156248',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_3_1_1_1.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_3_1_1_1.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_3_1_1_1.png',
                name: 'Série Spéciale Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156248',
                included_services:
                    "Internet \r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi \r\nWIFI Ultym partout dans la maison \r\nWIFI 6 E dernière génération \r\nInstallation fibre & Bbox 100 % accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WIFI\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France / Europe/Suisse et vers fixes de plus de 110 pays \r\nAppels illimités vers les mobiles en France/Europe/Suisse\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Gaming FTTH 3P 49,99E ENG 24M',
                has_description: false,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72155553',
                    '72155787',
                    '72155901',
                    '72156118',
                    '72156162',
                    '72154489',
                    '72156459',
                    '72156439',
                    '72155638',
                    '72155641',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72152176',
                    '72154931',
                    '72155924',
                    '72154932',
                    '72155268',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_3_1_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156248',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156248',
                    },
                    etendu: {
                        href: '/ventes/produits/72156248/etendu',
                    },
                },
                convergence: true,
                option: {
                    id: '72155901',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '1 Gb/s',
                },
            },
            {
                entity_id: '10953',
                type_id: 'fai',
                sku: '72156250',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'sl_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must Gaming WIFI 6 FTTH 3P 39,99E ENG 24M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156250',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_3_1.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_3_1.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_3_1.png',
                name: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156250',
                included_services:
                    "Internet \r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi \r\nDiagnostique Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France et vers\r\nfixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois ",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Gaming WIFI 6 FTTH 3P 39,99E ENG 24M',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72155754',
                    '72155642',
                    '72156190',
                    '72155638',
                    '72155641',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//b/b/bbox_must_ftth_1_1_3_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156250',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156250',
                    },
                    etendu: {
                        href: '/ventes/produits/72156250/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10955',
                type_id: 'fai',
                sku: '72156252',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'bbox_smart_tv',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_eole',
                technical_label: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P 39,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156252',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_smart_tv_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_must_smart_tv_1_1.png',
                image: '/media/catalog/product/b/b/bbox_must_smart_tv_1_1.png',
                name: 'Bbox Must Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156252-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P 39,99E ENG 24M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154926',
                    '72155553',
                    '72156118',
                    '72156201',
                    '72154460',
                    '72156460',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156190',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72152176',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_8_2_2_2_1_3_1.png',
                    'media/catalog/product//b/b/bbox_must_smart_tv_1_1.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156252-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156252',
                    },
                    etendu: {
                        href: '/ventes/produits/72156252/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10929',
                type_id: 'fai',
                sku: '72156256',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'bbox_smart_tv_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gbit/s',
                speed_up: '900 Mbit/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended',
                technical_label: 'Bbox Ultym Smart TV FTTH 2P 49,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Ultym Smart TV FTTH 2P 49,99E ENG 24M',
                gencode: '72156256',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_2_2.png',
                small_image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_2_2.png',
                image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_2_2.png',
                name: 'Bbox Ultym Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156256',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien \r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Smart TV FTTH 2P 49,99E ENG 24M',
                has_description: true,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72155553',
                    '72156460',
                    '72156162',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155474',
                    '72156190',
                    '72154932',
                    '72154731',
                    '72155390',
                    '72155268',
                    '72155925',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/t/bt_eole-4k-side_00000_1__3_2_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156256',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156256',
                    },
                    etendu: {
                        href: '/ventes/produits/72156256/etendu',
                    },
                },
                convergence: true,
                option: {
                    id: '72155901',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '1 Gb/s',
                },
            },
            {
                entity_id: '10959',
                type_id: 'fai',
                sku: '72156278',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 33.99,
                range: 'ss_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéciale Bbox Must FTTH 3P 33,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156278',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_14.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_14.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_14.png',
                name: 'Série Spéciale Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156278-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox Must WIFI 6 FTTH 3P 33,99E ENG 12M\r\n',
                has_description: false,
                final_price: 33.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72154731',
                    '72155140',
                    '72152176',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '3523930101946',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156278-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156278',
                    },
                    etendu: {
                        href: '/ventes/produits/72156278/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10933',
                type_id: 'fai',
                sku: '72156280',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 26.99,
                range: 'se_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéciale Bbox WIFI 6 FTTH 3P 26,99E SANS ENG',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Fibre (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156280',
                sim_type: 'default',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_8.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_8.png',
                image: '/media/catalog/product/e/o/eole_vancouver_8.png',
                name: 'Série Spéciale Bbox Fibre Exclu B&You (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156280-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox WIFI 6 FTTH 3P 26,99E SANS ENG\r\n',
                has_description: true,
                final_price: 26.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156439',
                    '72156100',
                    '72154926',
                    '72155553',
                    '72156118',
                    '72156215',
                    '72156162',
                    '72154460',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72155641',
                    '72155638',
                    '72155642',
                    '72156190',
                    '72155754',
                    '72154731',
                    '72155140',
                    '72152176',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_8.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '3523930101946',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156280-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156280',
                    },
                    etendu: {
                        href: '/ventes/produits/72156280/etendu',
                    },
                },
                convergence: false,
                option: {
                    id: '72155901',
                    price: 5,
                    speed_down: '8 Gb/s',
                    speed_up: '1 Gb/s',
                },
            },
            {
                entity_id: '11372',
                type_id: 'fai',
                sku: '72156541',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 28.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'SP Bbox Must Mobile WIFI 6 FTTH 3P 28,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156541',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2.png',
                name: 'Série Spéciale Bbox Must Mobile (FTTH) : Internet - TV – Téléphonie',
                url_key: '72156541-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: true,
                final_price: 28.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72154731',
                    '72155140',
                    '72152176',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '3523930101946',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156541-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156541',
                    },
                    etendu: {
                        href: '/ventes/produits/72156541/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '11380',
                type_id: 'fai',
                sku: '72156543',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'ss_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'SP Bbox Must Mobile WIFI 6 FTTH 3P 29,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156543',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2_2.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_17_2_2_2_2_2.png',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156543-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_old',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: true,
                final_price: 29.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72156459',
                    '72156118',
                    '72155553',
                    '72154926',
                    '72156162',
                    '72156439',
                    '72156206',
                    '72154460',
                    '72156205',
                    '72156201',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72156190',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72152176',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '3523930101946',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156543-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156543',
                    },
                    etendu: {
                        href: '/ventes/produits/72156543/etendu',
                    },
                },
                convergence: true,
            },
        ],
        offersWithOptions: [],
        ocs: [],
        cache: {
            '/offres-internet/test-eligibilite': {
                FTTH: [
                    {
                        entity_id: '10847',
                        type_id: 'fai',
                        sku: '72156220',
                        qty: 0,
                        position: '0',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '0',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        price: 31.99,
                        range: 'ss_medium_banque',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv',
                        technical_label: 'Série Spéciale Bbox 4K Wifi 6 FTTH 3P',
                        unbundling: 'total',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                        gencode: '72156220',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/t/bt_polymele.png',
                        small_image: '/media/catalog/product/b/t/bt_polymele.png',
                        image: '/media/catalog/product/b/t/bt_polymele.png',
                        name: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                        url_key: '72156220-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation Fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\nInternet garanti avec clé 4G\r\n\r\nTV\r\nPlus de 180 chaînes\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie Fixe\r\nAppels illimités vers les fixes et mobiles en France et vers fixes de plus de 110 pays",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,DEMENAGEMENT',
                        network: 'partenaires',
                        short_description: 'Série Spéciale Bbox Banque 4K Wifi 6 FTTH 3P 31,99E ENG 12M',
                        has_description: false,
                        final_price: 31.99,
                        ecotax: 0,
                        categories: ['FAI-BANQUE-WEB'],
                        upSellsProducts: [
                            '72156162',
                            '72155553',
                            '72155687',
                            '72156100',
                            '72156118',
                            '72156201',
                            '72156205',
                            '72154460',
                            '72156206',
                            '72156439',
                            '72156459',
                            '72155638',
                            '72154931',
                            '72154087',
                            '72154560',
                            '72155924',
                            '72155268',
                            '72154085',
                            '72152176',
                            '72155140',
                            '72155641',
                            '72155754',
                            '72155390',
                            '72155642',
                            '72154462',
                            '72154459',
                            '72151539',
                            '72150761',
                            '72153256',
                            '72154082',
                            '72154115',
                            '72154932',
                            '72154731',
                        ],
                        medias: [],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3499550359077',
                            '3523930104947',
                            '3760274861789',
                            '3770008652965',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '3662515018740',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-banque-web/72156220-engagement',
                        relatedProduct: ['72155144'],
                        tax: 0,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156220',
                            },
                            etendu: {
                                href: '/ventes/produits/72156220/etendu',
                            },
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10936',
                        type_id: 'fai',
                        sku: '72156229',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 29.99,
                        range: 'small',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '400 Mb/s',
                        speed_up: '400 Mb/s',
                        equipment: 'internet',
                        technical_label: 'Bbox Fit FTTH 2P 29,99E ENG 12M',
                        commercial_range: 'Bbox fit',
                        unbundling: 'aucun',
                        play: '2P',
                        technology: 'FTTH',
                        label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                        gencode: '72156229',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                        small_image: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                        image: '/media/catalog/product/b/b/bbox_fit_1_28_2_3_3_1_1.png',
                        name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                        url_key: '72156229-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Fit FTTH 2P 29,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 29.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72156439',
                            '72154460',
                            '72154474',
                            '72156162',
                            '72156118',
                            '72156100',
                            '72156190',
                            '72154932',
                            '72154731',
                            '72154424',
                            '72155390',
                            '72153256',
                            '72155563',
                            '72151539',
                        ],
                        medias: ['media/catalog/product//b/b/bbox_fit_1_28_2_3_3_1_1.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156229-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156229',
                            },
                            etendu: {
                                href: '/ventes/produits/72156229/etendu',
                            },
                        },
                        promotion: {
                            amount: 14,
                            duration: 6,
                            description: 'Remise Bbox Fit',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10941',
                        type_id: 'fai',
                        sku: '72156234',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 39.99,
                        range: 'medium',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '1 Gb/s',
                        speed_up: '700 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv_eole',
                        technical_label: 'Bbox Must WIFI 6 FTTH 3P 39,99E ENG 12M',
                        commercial_range: 'Bbox must',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                        gencode: '72156234',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                        small_image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                        image: '/media/catalog/product/b/b/bbox_must_ftth_1_1_13.png',
                        name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156234-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Must WIFI 6 FTTH 3P 39,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 39.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72154926',
                            '72156118',
                            '72156162',
                            '72156206',
                            '72156201',
                            '72154460',
                            '72156205',
                            '72156459',
                            '72156439',
                            '72155641',
                            '72155638',
                            '72156190',
                            '72155642',
                            '72155754',
                            '72154731',
                            '72155140',
                            '72152176',
                            '72154931',
                            '72155268',
                            '72154932',
                            '72154115',
                            '72153256',
                            '72154082',
                            '72154085',
                            '72155390',
                            '72154087',
                            '72154459',
                            '72154462',
                            '72154560',
                            '72151539',
                            '72150761',
                        ],
                        medias: [
                            'media/catalog/product//b/b/bbox_ultym_1_8_2_2_2_2_6.png',
                            'media/catalog/product//b/b/bbox_must_ftth_1_1_13.png',
                        ],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '3523930101946',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156234-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156234',
                            },
                            etendu: {
                                href: '/ventes/produits/72156234/etendu',
                            },
                        },
                        promotion: {
                            amount: 16,
                            duration: 6,
                            description: 'Remise Bbox Must',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10925',
                        type_id: 'fai',
                        sku: '72156241',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 49.99,
                        range: 'large',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '2 Gb/s',
                        speed_up: '900 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_extended_box_tv_hdr',
                        technical_label: 'Bbox Ultym FTTH 3P 49,99E ENG 12M',
                        commercial_range: 'Bbox ultym',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox Ultym FTTH 3P 47,99E ENG 12M',
                        gencode: '72156241',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                        small_image: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                        image: '/media/catalog/product/e/o/eole_vancouver_6_3_5.png',
                        name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156241',
                        included_services:
                            "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Ultym FTTH 3P 49,99E ENG 12M',
                        has_description: false,
                        final_price: 49.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72156118',
                            '72155553',
                            '72155787',
                            '72155901',
                            '72156162',
                            '72154489',
                            '72156459',
                            '72156439',
                            '72156190',
                            '72155638',
                            '72155641',
                            '72155642',
                            '72155754',
                            '72155140',
                            '72155924',
                            '72154731',
                            '72152176',
                            '72154931',
                            '72154932',
                            '72155268',
                            '72155390',
                            '72153256',
                            '72154115',
                            '72154082',
                            '72154085',
                            '72154087',
                            '72154560',
                            '72151539',
                            '72150761',
                            '72154459',
                            '72154462',
                        ],
                        medias: ['media/catalog/product//e/o/eole_vancouver_6_3_5.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156241',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156241',
                            },
                            etendu: {
                                href: '/ventes/produits/72156241/etendu',
                            },
                        },
                        promotion: {
                            amount: 20,
                            duration: 6,
                            description: 'Remise Bbox Ultym',
                        },
                        convergence: true,
                        option: {
                            id: '72155901',
                            price: 5,
                            speed_down: '8 Gb/s',
                            speed_up: '1 Gb/s',
                        },
                    },
                ],
            },
        },
        mustGetOffers: false,
        eligType: 'search',
        userId: null,
    },
    expiresTimestamp: null,
};

export const MOCK_BYPASS = {
    data: {
        idPanier: '65c09a04d9e06c121c540a9a',
        techno: 'FTTH',
        address: {
            codePostal: '75015',
            voie: 'RUE DE LOURMEL',
            commune: 'PARIS 15',
            numeroVoie: '75',
            inlineSplit: ['75  RUE DE LOURMEL', '75015 PARIS 15'],
            inline: '75  RUE DE LOURMEL 75015 PARIS 15',
        },
        technicalAddress: {
            zipCode: '75015',
            city: {
                label: 'PARIS 15',
                INSEECode: '75115',
            },
            street: {
                label: 'RUE DE LOURMEL',
                rivoliCode: '5814',
            },
            streetNumber: {
                number: '75',
                complement: '',
                label: '75',
            },
            hexaKey: '7511522CV9',
            id: '75115LOURL00143',
            imb: 'IMB/75115/C/00BU',
        },
        results: {
            ftth: {
                offers: [
                    '72156516',
                    '72156532',
                    '72156550',
                    '72155959',
                    '72155938',
                    '72156518',
                    '72156544',
                    '72156536',
                    '72156255',
                    '72156540',
                    '72156279',
                    '72156542',
                    '72155934',
                    '72155383',
                    '72155442',
                    '72156172',
                    '72156257',
                    '72155241',
                    '72156251',
                    '72156242',
                    '72156253',
                    '72156522',
                    '72156170',
                    '72156230',
                    '72156546',
                    '72156188',
                    '72156548',
                    '72155936',
                    '72156249',
                    '72156538',
                    '72155668',
                    '72156259',
                    '72155784',
                    '72155706',
                    '72155920',
                    '72155207',
                    '72155782',
                    '72156221',
                    '72155966',
                    '72156520',
                    '72156235',
                    '72156281',
                    '72156530',
                    '72156534',
                    '72155932',
                    '72155918',
                    '72155223',
                ],
                status: true,
                technoType: 'ftth',
                forecast: {
                    name: 'FTTH_DANS_LA_VILLE',
                    date: '2018-07-09',
                    program: 'FTTH',
                },
                buildings: [
                    {
                        building: '_NA_',
                        stairs: [
                            {
                                stair: '0',
                                stages: [
                                    {
                                        floor: '0',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-2875-2999',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                        type: 'PAVILLON',
                        ptoPresenceRate: 'SATISFAISANT',
                    },
                ],
                shouldBypass: true,
                groupeCategorieRaccoLogement: 'PBO_AERIEN',
                housingType: 'PAVILLON',
                pmLocationType: 'PME',
                pto: 'FI-2875-2999',
            },
            xdsl: {
                offers: [],
                status: false,
                technoType: 'xdsl',
            },
            box4g: {
                offers: [],
                status: false,
                technoType: 'box4g',
            },
            box5g: {
                offers: [],
                status: false,
                technoType: 'box5g',
            },
        },
        offers: [
            {
                entity_id: '6595',
                type_id: 'fai',
                sku: '72155207',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                is_highlighted: false,
                exclu_assos: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro + (FTTH) : Internet - TV - Téléphonie ',
                image: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                small_image: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                thumbnail: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155207',
                label: 'Bbox Pro+ (FTTH) :  Internet - TV - Téléphonie',
                technology: 'FTTH',
                play: '3P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 3P ZE 50,99E ENG 12M',
                equipment: 'internet_box_tv_eole',
                support_stockage: 'Enregistreur 128 Go inclus',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155207-engagement-1-1',
                short_description: 'Une offre renforcée avec un Wi-Fi<br> étendu et la TV en 4K',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155268',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_7_2_1_1.png',
                    'media/catalog/product//v/i/visuel_ultym_2_10_1_1.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155207-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155207',
                    },
                    etendu: {
                        href: '/ventes/produits/72155207/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '6609',
                type_id: 'fai',
                sku: '72155223',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                image: '/media/catalog/product/e/o/eole_vancouver_2.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_2.png',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155223',
                label: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                technology: 'FTTH',
                play: '2P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 2P ZE 50,99E ENG 12M',
                equipment: 'internet_box_tv_hdr',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155223-engagement-1-1-1',
                short_description: 'Essentiel de la fibre',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_fit_1_28_2_2_2_1.png',
                    'media/catalog/product//b/t/bt_eole-4k-front_00001_3.png',
                    'media/catalog/product//e/o/eole_vancouver_2.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155223-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155223',
                    },
                    etendu: {
                        href: '/ventes/produits/72155223/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '9039',
                type_id: 'fai',
                sku: '72155782',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                equipment: 'internet_eole',
                technical_label: 'Bbox Pro Wi-Fi 6 FTTH 2P ZE 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) : Internet - Téléphonie',
                gencode: '72155782',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : : Internet - Téléphonie',
                url_key: '72155782-engagement-1-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Essentiel de la fibre',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_28_2_2_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155782-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155782',
                    },
                    etendu: {
                        href: '/ventes/produits/72155782/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '9041',
                type_id: 'fai',
                sku: '72155784',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                support_stockage: 'Enregistreur 128 Go inclus',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Pro FTTH 3P ZE 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72155784',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : Internet - TV - Téléphonie',
                url_key: '72155784-engagement-1-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72156439',
                    '72155390',
                    '72155553',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                    '72155268',
                ],
                medias: ['media/catalog/product//b/b/bbox_ultym_1_9_1_1_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72155784-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155784',
                    },
                    etendu: {
                        href: '/ventes/produits/72155784/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '10848',
                type_id: 'fai',
                sku: '72156221',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '0',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                price: 31.99,
                range: 'ss_medium_banque',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv',
                technical_label: 'Série Spéciale Bbox 4K Wifi 6 FTTH 3P ZE',
                unbundling: 'total',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                gencode: '72156221',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/t/bt_polymele_1.png',
                small_image: '/media/catalog/product/b/t/bt_polymele_1.png',
                image: '/media/catalog/product/b/t/bt_polymele_1.png',
                name: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                url_key: '72156221-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation Fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\nInternet garanti avec clé 4G\r\n\r\nTV\r\nPlus de 180 chaînes\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie Fixe\r\nAppels illimités vers les fixes et mobiles en France et vers fixes de plus de 110 pays",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,DEMENAGEMENT',
                network: 'partenaires',
                short_description: 'Série Spéciale Bbox Banque 4K Wifi 6 FTTH 3P ZE 31,99E ENG 12M',
                has_description: false,
                final_price: 31.99,
                ecotax: 0,
                categories: ['FAI-BANQUE-WEB'],
                upSellsProducts: [
                    '72156162',
                    '72155553',
                    '72155687',
                    '72156100',
                    '72156118',
                    '72156201',
                    '72156205',
                    '72154460',
                    '72156206',
                    '72156439',
                    '72156459',
                    '72155638',
                    '72154931',
                    '72154087',
                    '72154560',
                    '72155924',
                    '72155268',
                    '72154085',
                    '72152176',
                    '72155140',
                    '72155641',
                    '72155754',
                    '72155390',
                    '72155642',
                    '72154462',
                    '72154459',
                    '72151539',
                    '72150761',
                    '72153256',
                    '72154082',
                    '72154115',
                    '72154932',
                    '72154731',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-banque-web/72156221-engagement',
                relatedProduct: ['72155144'],
                tax: 0,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156221',
                    },
                    etendu: {
                        href: '/ventes/produits/72156221/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10937',
                type_id: 'fai',
                sku: '72156230',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'small',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '400 Mb/s',
                speed_up: '400 Mb/s',
                equipment: 'internet',
                technical_label: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M',
                commercial_range: 'Bbox fit',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                gencode: '72156230',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                url_key: '72156230-engagement',
                included_services:
                    "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M\r\n',
                has_description: false,
                final_price: 29.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72156439',
                    '72154460',
                    '72154474',
                    '72156162',
                    '72156118',
                    '72156100',
                    '72156190',
                    '72154932',
                    '72154731',
                    '72154424',
                    '72155390',
                    '72153256',
                    '72155563',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_29_1_1_3_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156230-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156230',
                    },
                    etendu: {
                        href: '/ventes/produits/72156230/etendu',
                    },
                },
                promotion: {
                    amount: 14,
                    duration: 6,
                    description: 'Remise Bbox Fit',
                },
                convergence: true,
            },
            {
                entity_id: '10942',
                type_id: 'fai',
                sku: '72156235',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156235',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156235-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_9_1_3_2_1_5.png',
                    'media/catalog/product//b/b/bbox_must_ftth_2_5.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156235-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156235',
                    },
                    etendu: {
                        href: '/ventes/produits/72156235/etendu',
                    },
                },
                promotion: {
                    amount: 16,
                    duration: 6,
                    description: 'Remise Bbox Must',
                },
                convergence: true,
            },
            {
                entity_id: '10926',
                type_id: 'fai',
                sku: '72156242',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox ultym (FTTH) :  Internet - TV - Téléphonie',
                gencode: '72156242',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156242',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M\r\n',
                has_description: true,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156459',
                    '72156439',
                    '72156162',
                    '72154489',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72155754',
                    '72156190',
                    '72152176',
                    '72155924',
                    '72154731',
                    '72155140',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_4_7.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156242',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156242',
                    },
                    etendu: {
                        href: '/ventes/produits/72156242/etendu',
                    },
                },
                promotion: {
                    amount: 20,
                    duration: 6,
                    description: 'Remise Bbox Ultym',
                },
                convergence: true,
            },
            {
                entity_id: '10928',
                type_id: 'fai',
                sku: '72156249',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'sl_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: 'Bbox Ultym Gaming FTTH 3P ZE 49,99E ENG 24M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156249',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                name: 'Série Spéciale Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156249',
                included_services:
                    "Internet \r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi \r\nWIFI Ultym partout dans la maison \r\nWIFI 6 E dernière génération \r\nInstallation fibre & Bbox 100 % accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WIFI\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France / Europe/Suisse et vers fixes de plus de 110 pays \r\nAppels illimités vers les mobiles en France/Europe/Suisse\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Gaming FTTH 3P ZE 49,99E ENG 24M',
                has_description: false,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156459',
                    '72156439',
                    '72156162',
                    '72154489',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72155754',
                    '72156190',
                    '72152176',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155924',
                    '72154932',
                    '72155268',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_3_3_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156249',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156249',
                    },
                    etendu: {
                        href: '/ventes/produits/72156249/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10954',
                type_id: 'fai',
                sku: '72156251',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'sl_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must Gaming WIFI 6 FTTH 3P ZE 39,99E ENG 24M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156251',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                name: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156251',
                included_services:
                    "Internet \r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi \r\nDiagnostique Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France et vers\r\nfixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois ",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Gaming WIFI 6 FTTH 3P ZE 39,99E ENG 24M',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72155754',
                    '72155642',
                    '72156190',
                    '72155638',
                    '72155641',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//b/b/bbox_must_ftth_2_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156251',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156251',
                    },
                    etendu: {
                        href: '/ventes/produits/72156251/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10956',
                type_id: 'fai',
                sku: '72156253',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'bbox_smart_tv',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_eole',
                technical_label: 'Bbox Must Smart TV FTTH 2P ZE 39,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P ZE',
                gencode: '72156253',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                small_image: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                image: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                meta_title: ' ',
                name: 'Bbox Must Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156253-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P ZE 39,99E ENG 24M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154926',
                    '72156460',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72156162',
                    '72156118',
                    '72155553',
                    '72154460',
                    '72155642',
                    '72155638',
                    '72155641',
                    '72155754',
                    '72156190',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72152176',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_8_2_2_2_1_1_1_2.png',
                    'media/catalog/product//b/b/bbox_must_smart_tv_3.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156253-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156253',
                    },
                    etendu: {
                        href: '/ventes/produits/72156253/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10930',
                type_id: 'fai',
                sku: '72156257',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'bbox_smart_tv_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gbit/s',
                speed_up: '900 Mbit/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended',
                technical_label: 'Bbox Ultym Smart TV FTTH 2P ZE 49,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox ultym Smart TV (FTTH) : Internet - Téléphonie - TV + Smart TV',
                gencode: '72156257',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                small_image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                name: 'Bbox Ultym Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156257',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Smart TV FTTH 2P ZE 49,99E ENG 24M\r\n',
                has_description: true,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156460',
                    '72156162',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72156190',
                    '72154932',
                    '72155474',
                    '72154731',
                    '72155268',
                    '72155390',
                    '72155925',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/t/bt_eole-4k-side_00000_1__3_1_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/72156257',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156257',
                    },
                    etendu: {
                        href: '/ventes/produits/72156257/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10960',
                type_id: 'fai',
                sku: '72156279',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 33.99,
                range: 'ss_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéciale Bbox Must FTTH 3P ZE 33,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156279',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                name: 'Série Spéciale Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156279-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox Must WIFI 6 FTTH 3P ZE 33,99E ENG 12M\r\n',
                has_description: false,
                final_price: 33.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156279-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156279',
                    },
                    etendu: {
                        href: '/ventes/produits/72156279/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10934',
                type_id: 'fai',
                sku: '72156281',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 26.99,
                range: 'se_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéc Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Fibre (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156281',
                sim_type: 'default',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_9.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                name: 'Série Spéciale Bbox Fibre Exclu B&You (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156281-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG\r\n',
                has_description: true,
                final_price: 26.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156439',
                    '72156118',
                    '72154926',
                    '72155553',
                    '72156100',
                    '72156162',
                    '72154460',
                    '72156215',
                    '72156201',
                    '72156205',
                    '72156206',
                    '72155638',
                    '72155641',
                    '72155642',
                    '72155754',
                    '72156190',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72152176',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_9.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156281-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156281',
                    },
                    etendu: {
                        href: '/ventes/produits/72156281/etendu',
                    },
                },
                convergence: false,
            },
            {
                entity_id: '11376',
                type_id: 'fai',
                sku: '72156542',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 28.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'SP Must Mobile WIFI 6 FTTH 3P ZE 28,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156542',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                name: 'Série Spéciale Bbox Must Mobile (FTTH) : Internet - TV – Téléphonie',
                url_key: '72156542-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: true,
                final_price: 28.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155642',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156542-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156542',
                    },
                    etendu: {
                        href: '/ventes/produits/72156542/etendu',
                    },
                },
                convergence: true,
            },
        ],
        offersWithOptions: [],
        ocs: [],
        cache: {
            '/offres-internet/test-eligibilite': {
                FTTH: [
                    {
                        entity_id: '10848',
                        type_id: 'fai',
                        sku: '72156221',
                        qty: 0,
                        position: '0',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '0',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        price: 31.99,
                        range: 'ss_medium_banque',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv',
                        technical_label: 'Série Spéciale Bbox 4K Wifi 6 FTTH 3P ZE',
                        unbundling: 'total',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                        gencode: '72156221',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/t/bt_polymele_1.png',
                        small_image: '/media/catalog/product/b/t/bt_polymele_1.png',
                        image: '/media/catalog/product/b/t/bt_polymele_1.png',
                        name: 'Série Spéciale Bbox Banque : Internet - TV - Téléphonie',
                        url_key: '72156221-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation Fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\nInternet garanti avec clé 4G\r\n\r\nTV\r\nPlus de 180 chaînes\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie Fixe\r\nAppels illimités vers les fixes et mobiles en France et vers fixes de plus de 110 pays",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,DEMENAGEMENT',
                        network: 'partenaires',
                        short_description: 'Série Spéciale Bbox Banque 4K Wifi 6 FTTH 3P ZE 31,99E ENG 12M',
                        has_description: false,
                        final_price: 31.99,
                        ecotax: 0,
                        categories: ['FAI-BANQUE-WEB'],
                        upSellsProducts: [
                            '72156162',
                            '72155553',
                            '72155687',
                            '72156100',
                            '72156118',
                            '72156201',
                            '72156205',
                            '72154460',
                            '72156206',
                            '72156439',
                            '72156459',
                            '72155638',
                            '72154931',
                            '72154087',
                            '72154560',
                            '72155924',
                            '72155268',
                            '72154085',
                            '72152176',
                            '72155140',
                            '72155641',
                            '72155754',
                            '72155390',
                            '72155642',
                            '72154462',
                            '72154459',
                            '72151539',
                            '72150761',
                            '72153256',
                            '72154082',
                            '72154115',
                            '72154932',
                            '72154731',
                        ],
                        medias: [],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/offres-internet-elig/fai-banque-web/72156221-engagement',
                        relatedProduct: ['72155144'],
                        tax: 0,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156221',
                            },
                            etendu: {
                                href: '/ventes/produits/72156221/etendu',
                            },
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10937',
                        type_id: 'fai',
                        sku: '72156230',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 29.99,
                        range: 'small',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '400 Mb/s',
                        speed_up: '400 Mb/s',
                        equipment: 'internet',
                        technical_label: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M',
                        commercial_range: 'Bbox fit',
                        unbundling: 'aucun',
                        play: '2P',
                        technology: 'FTTH',
                        label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                        gencode: '72156230',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        small_image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                        url_key: '72156230-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 29.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72156439',
                            '72154460',
                            '72154474',
                            '72156162',
                            '72156118',
                            '72156100',
                            '72156190',
                            '72154932',
                            '72154731',
                            '72154424',
                            '72155390',
                            '72153256',
                            '72155563',
                            '72151539',
                        ],
                        medias: ['media/catalog/product//b/b/bbox_fit_1_29_1_1_3_1_1.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156230-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156230',
                            },
                            etendu: {
                                href: '/ventes/produits/72156230/etendu',
                            },
                        },
                        promotion: {
                            amount: 14,
                            duration: 6,
                            description: 'Remise Bbox Fit',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10942',
                        type_id: 'fai',
                        sku: '72156235',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 39.99,
                        range: 'medium',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '1 Gb/s',
                        speed_up: '700 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv_eole',
                        technical_label: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M',
                        commercial_range: 'Bbox must',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                        gencode: '72156235',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156235-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 39.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72154926',
                            '72156118',
                            '72156162',
                            '72156206',
                            '72156201',
                            '72154460',
                            '72156205',
                            '72156459',
                            '72156439',
                            '72155641',
                            '72155638',
                            '72156190',
                            '72155642',
                            '72155754',
                            '72155140',
                            '72154731',
                            '72154931',
                            '72155268',
                            '72154932',
                            '72152176',
                            '72154115',
                            '72153256',
                            '72154082',
                            '72155390',
                            '72154085',
                            '72154087',
                            '72154459',
                            '72154462',
                            '72154560',
                            '72151539',
                            '72150761',
                        ],
                        medias: [
                            'media/catalog/product//b/b/bbox_ultym_1_9_1_3_2_1_5.png',
                            'media/catalog/product//b/b/bbox_must_ftth_2_5.png',
                        ],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3523930101946',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156235-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156235',
                            },
                            etendu: {
                                href: '/ventes/produits/72156235/etendu',
                            },
                        },
                        promotion: {
                            amount: 16,
                            duration: 6,
                            description: 'Remise Bbox Must',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10926',
                        type_id: 'fai',
                        sku: '72156242',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 49.99,
                        range: 'large',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '2 Gb/s',
                        speed_up: '900 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_extended_box_tv_hdr',
                        technical_label: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M',
                        commercial_range: 'Bbox ultym',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox ultym (FTTH) :  Internet - TV - Téléphonie',
                        gencode: '72156242',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        small_image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156242',
                        included_services:
                            "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M\r\n',
                        has_description: true,
                        final_price: 49.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72156459',
                            '72156439',
                            '72156162',
                            '72154489',
                            '72156118',
                            '72155901',
                            '72155787',
                            '72155553',
                            '72155638',
                            '72155641',
                            '72155642',
                            '72155754',
                            '72156190',
                            '72152176',
                            '72155924',
                            '72154731',
                            '72155140',
                            '72154931',
                            '72155268',
                            '72154932',
                            '72155390',
                            '72153256',
                            '72154115',
                            '72154082',
                            '72154085',
                            '72154087',
                            '72154560',
                            '72151539',
                            '72150761',
                            '72154459',
                            '72154462',
                        ],
                        medias: ['media/catalog/product//e/o/eole_vancouver_6_4_7.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap2.bouyguestelecom.fr/fai-simo/72156242',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156242',
                            },
                            etendu: {
                                href: '/ventes/produits/72156242/etendu',
                            },
                        },
                        promotion: {
                            amount: 20,
                            duration: 6,
                            description: 'Remise Bbox Ultym',
                        },
                        convergence: true,
                    },
                ],
            },
        },
        mustGetOffers: false,
        eligType: 'search',
        userId: null,
    },
    expiresTimestamp: null,
};

export const BOX4G_MOCK = {
    data: {
        idPanier: '6597fa49f0d44d12dcb3ae39',
        techno: 'BOX_4G',
        address: {
            codePostal: '77940',
            voie: 'ROUTE DU CHEVINOIS',
            commune: 'LA BROSSE MONTCEAUX',
            numeroVoie: '2',
            nd: '0160727045',
            inlineSplit: ['2  ROUTE DU CHEVINOIS', '77940 LA BROSSE MONTCEAUX'],
            inline: '2  ROUTE DU CHEVINOIS 77940 LA BROSSE MONTCEAUX',
        },
        technicalAddress: {
            zipCode: '77940',
            city: {
                label: 'LA BROSSE MONTCEAUX',
                INSEECode: '77054',
            },
            street: {
                label: 'ROUTE DU CHEVINOIS',
                rivoliCode: '0060',
            },
            streetNumber: {
                number: '2',
                complement: '',
                label: '2',
            },
        },
        results: {
            ftth: {
                offers: [],
                status: false,
                technoType: 'ftth',
                shouldBypass: false,
            },
            xdsl: {
                offers: [
                    '72155191',
                    '72155202',
                    '72155203',
                    '72155212',
                    '72155213',
                    '72155221',
                    '72155838',
                    '72155190',
                    '72155220',
                    '72155282',
                    '72155316',
                    '72155328',
                    '72155439',
                    '72156174',
                    '72156181',
                    '72156233',
                    '72156239',
                    '72155940',
                    '72155440',
                    '72155848',
                    '72155808',
                    '72155963',
                    '72155970',
                ],
                status: true,
                technoType: 'xdsl',
                speedUp: 12,
                speedDown: 70,
            },
            box4g: {
                offers: ['6484', '6684', '6683', '6364', '6753', '6733'],
                status: true,
                technoType: 'box4g',
                homeZone: 'HZ2-T77001',
            },
            box5g: {
                offers: [],
                status: false,
                technoType: 'box5g',
            },
        },
        offers: [
            {
                entity_id: '10093',
                type_id: 'faim_unlimited',
                sku: '6733',
                qty: 1,
                position: '1',
                rental_fees: 3,
                locked: '0',
                exclu_pro: false,
                banking_offer: false,
                transfer_offer: false,
                is_highlighted: false,
                exclu_assos: false,
                to_scan: false,
                price: 33.99,
                auto_add_front: 'fai-fmd,generic-box-fai',
                auto_add_back: '6901443179664',
                technology: 'BOX_4G',
                gencode: '6733',
                sim_type: 'default',
                name: '4G box',
                produit_prioritaire: '6901443179664',
                classification: 'medium_xgbox',
                url_key: '4g-box-6733',
                short_description: '4G box',
                fai_category_type: 'offre_gp',
                included_services:
                    "Internet en 4G\r\nJusqu'à 220 Mbit/s (débit descendant)\r\nJusqu'à 38 Mbit/s (débit montant)\r\n\r\nTV sur smartphone et tablette\r\n+ de 70 chaînes avec l'application B.tv",
                has_description: false,
                final_price: 33.99,
                ecotax: 0,
                categories: ['faim_unlimited'],
                upSellsProducts: ['11148', '13809'],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                fmd: 19,
                box: ['6901443179664', '4894461887302', '6972453162250'],
                crossSellsProducts: ['3526356054230'],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/forfait-internet-mobile-illimite/4g-box-6733',
                relatedProduct: [],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/6733',
                    },
                    etendu: {
                        href: '/ventes/produits/6733/etendu',
                    },
                },
                range: 'medium_xgbox',
                speed_up: '38 Mb/s',
                speed_down: '220 Mb/s',
                convergence: true,
            },
            {
                entity_id: '10309',
                type_id: 'faim_unlimited',
                sku: '6753',
                qty: 1,
                position: '1',
                rental_fees: 3,
                locked: '0',
                exclu_pro: false,
                banking_offer: false,
                transfer_offer: false,
                is_highlighted: false,
                exclu_assos: false,
                to_scan: false,
                price: 19.99,
                auto_add_front: 'fai-fmd,generic-box-fai',
                auto_add_back: '6901443179664',
                technology: 'BOX_4G',
                gencode: '6753',
                sim_type: 'default',
                name: '4G box -26 ans',
                classification: 'ss_medium_xgbox',
                produit_prioritaire: '6901443179664',
                url_key: '4g-box-26ans-6753',
                short_description: '4G box -26 ans',
                fai_category_type: 'offre_gp',
                included_services:
                    "Offre réservée aux –26 ans. Vérifier la pièce d'identité du client\r\n\r\nInternet en 4G\r\nJusqu'à 220 Mbit/s (débit descendant)\r\nJusqu'à 38 Mbit/s (débit montant)\r\n\r\nTV sur smartphone et tablette\r\n+ de 70 chaînes avec l'application B.tv",
                has_description: false,
                final_price: 19.99,
                ecotax: 0,
                categories: ['faim_unlimited'],
                upSellsProducts: ['11148', '13809'],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                fmd: 19,
                box: ['6901443179664', '4894461887302', '6972453162250'],
                crossSellsProducts: ['3526356054230'],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/forfait-internet-mobile-illimite/4g-box-26ans-6753',
                relatedProduct: [],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/6753',
                    },
                    etendu: {
                        href: '/ventes/produits/6753/etendu',
                    },
                },
                range: 'ss_medium_xgbox',
                speed_up: '38 Mb/s',
                speed_down: '220 Mb/s',
                convergence: true,
            },
            {
                entity_id: '6585',
                type_id: 'fai',
                sku: '72155190',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '0',
                duration_promo: '0',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: false,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 38.99,
                name: 'Bbox Pro (VDSL) :  Internet - TV - Téléphonie ',
                image: '/media/catalog/product/b/b/bbox_must_1_23_1_1_2.png',
                small_image: '/media/catalog/product/b/b/bbox_must_1_23_1_1_2.png',
                thumbnail: '/media/catalog/product/b/b/bbox_must_1_23_1_1_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155190',
                label: 'Bbox Pro (VDSL) :  Internet - TV - Téléphonie ',
                technology: 'VDSL',
                play: '3P',
                unbundling: 'total',
                range: 'medium',
                technical_label: 'Bbox Pro VDSL 3P DT FF ILL 38,99E ENG 12M',
                equipment: 'internet_box_tv',
                support_stockage: 'Enregistreur 128 Go sur demande',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                url_key: '72155190-engagement-1-1',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                network: 'dolmen',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                has_description: false,
                final_price: 38.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156439',
                    '72156206',
                    '72155269',
                    '72155390',
                    '72155553',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                    '72156186',
                ],
                medias: ['media/catalog/product//b/b/bbox_must_1_23_1_1_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930101946',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550359077',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72155190-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155190',
                    },
                    etendu: {
                        href: '/ventes/produits/72155190/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                convergence: true,
            },
            {
                entity_id: '6592',
                type_id: 'fai',
                sku: '72155202',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '0',
                duration_promo: '0',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: false,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 46.19,
                name: 'Bbox Pro+ (VDSL) :  Internet - TV - Téléphonie ',
                image: '/media/catalog/product/p/a/packshot_vancouver_r1_1__2_2.png',
                small_image: '/media/catalog/product/p/a/packshot_vancouver_r1_1__2_2.png',
                thumbnail: '/media/catalog/product/p/a/packshot_vancouver_r1_1__2_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155202',
                label: 'Bbox Pro+ (VDSL) :  Internet - TV - Téléphonie ',
                technology: 'VDSL',
                play: '3P',
                unbundling: 'total',
                range: 'large',
                technical_label: 'Bbox Pro+ VDSL 3P DT 46,19E ENG 12M',
                equipment: 'internet_box_tv_4KHDR',
                support_stockage: 'Enregistreur 128 Go inclus',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                url_key: '72155202-engagement-1-1-1-1',
                short_description: 'Une offre renforcée avec un Wi-Fi<br> étendu et la TV en 4K',
                network: 'dolmen',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                has_description: false,
                final_price: 46.19,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72155390',
                    '72155553',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155269',
                    '72156186',
                ],
                medias: [
                    'media/catalog/product//v/i/visuel_ultym_1_1_1_1_1_1_1.png',
                    'media/catalog/product//p/a/packshot_vancouver_r1_1__2_2.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72155202-engagement-1-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155202',
                    },
                    etendu: {
                        href: '/ventes/produits/72155202/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                convergence: true,
            },
            {
                entity_id: '6599',
                type_id: 'fai',
                sku: '72155212',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '0',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: false,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 38.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro (VDSL) : Internet - Téléphonie',
                image: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2.png',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155212',
                label: 'Bbox Pro (VDSL) : Internet - Téléphonie',
                technology: 'VDSL',
                play: '2P',
                unbundling: 'total',
                range: 'medium',
                technical_label: 'Bbox Pro VDSL 2P DT FF ILL 38,99E ENG 12M',
                equipment: 'internet',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                url_key: '72155212-engagement-1-1',
                short_description: 'Seulement Internet',
                network: 'dolmen',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                has_description: false,
                final_price: 38.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_19_11_1_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930101946',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550359077',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72155212-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155212',
                    },
                    etendu: {
                        href: '/ventes/produits/72155212/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                convergence: true,
            },
            {
                entity_id: '6606',
                type_id: 'fai',
                sku: '72155220',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '0',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: false,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 46.19,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro+ (VDSL) : Internet - Téléphonie',
                image: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2_2.png',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_19_11_1_2_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155220',
                label: 'Bbox Pro+ (VDSL) : Internet - Téléphonie',
                technology: 'VDSL',
                play: '2P',
                unbundling: 'total',
                range: 'large',
                technical_label: 'Bbox Pro+ VDSL 2P DT 46,19E ENG 12M',
                equipment: 'internet',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                url_key: '72155220-engagement-1-1-1',
                short_description: 'Seulement Internet',
                network: 'dolmen',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                has_description: false,
                final_price: 46.19,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72153256',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_19_11_1_2_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930101946',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550359077',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72155220-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155220',
                    },
                    etendu: {
                        href: '/ventes/produits/72155220/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                convergence: true,
            },
            {
                entity_id: '10940',
                type_id: 'fai',
                sku: '72156233',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '0',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'small',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                equipment: 'internet',
                technical_label: 'Bbox Fit VDSL 2P DT 29,99E ENG 12M',
                unbundling: 'total',
                play: '2P',
                technology: 'VDSL',
                label: 'Bbox fit (VDSL) : Internet - Téléphonie',
                gencode: '72156233',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                name: 'Bbox Fit (VDSL) : Internet - Téléphonie',
                url_key: '72156233-engagement',
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'dolmen',
                short_description: 'Bbox Fit VDSL 2P DT 29,99E ENG 12M\r\n',
                has_description: false,
                final_price: 29.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156439',
                    '72155553',
                    '72154460',
                    '72156162',
                    '72156118',
                    '72156100',
                    '72155688',
                    '72156190',
                    '72154932',
                    '72154731',
                    '72154424',
                    '72155390',
                    '72153256',
                    '72155563',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_26_1_1_2_2.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930101946',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550359077',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72156233-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156233',
                    },
                    etendu: {
                        href: '/ventes/produits/72156233/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                promotion: {
                    amount: 14,
                    duration: 6,
                    description: 'Remise Bbox Fit',
                },
                convergence: true,
            },
            {
                entity_id: '10946',
                type_id: 'fai',
                sku: '72156239',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '0',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv',
                technical_label: 'Bbox Must 4K VDSL 3P DT 39,99E ENG 12M',
                unbundling: 'total',
                play: '3P',
                technology: 'VDSL',
                label: 'Bbox must (VDSL) :  Internet - TV - Téléphonie ',
                gencode: '72156239',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                small_image: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                image: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                name: 'Bbox Must (VDSL) :  Internet - TV - Téléphonie',
                url_key: '72156239-engagement',
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'dolmen',
                short_description: 'Bbox Must 4K VDSL 3P DT 39,99E ENG 12M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156201',
                    '72156100',
                    '72156118',
                    '72156162',
                    '72155687',
                    '72154460',
                    '72156205',
                    '72156206',
                    '72156439',
                    '72156190',
                    '72155638',
                    '72154931',
                    '72154087',
                    '72154560',
                    '72155924',
                    '72155269',
                    '72154085',
                    '72152176',
                    '72155140',
                    '72155641',
                    '72156186',
                    '72155754',
                    '72154459',
                    '72151539',
                    '72154462',
                    '72155390',
                    '72154115',
                    '72150761',
                    '72153256',
                    '72154082',
                    '72155553',
                    '72154932',
                    '72154731',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_must_2_7_1_1_3.png',
                    'media/catalog/product//b/b/bbox_must_dsl_4_20.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3499550359077',
                    '3523930104947',
                    '3760274861789',
                    '3770008652965',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '3662515018740',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72156239-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156239',
                    },
                    etendu: {
                        href: '/ventes/produits/72156239/etendu',
                    },
                },
                speed_up: '12 Mb/s',
                speed_down: '70 Mb/s',
                promotion: {
                    amount: 16,
                    duration: 6,
                    description: 'Remise Bbox Must',
                },
                convergence: true,
            },
        ],
        offersWithOptions: [],
        ocs: [],
        cache: {
            '/offres-internet/test-eligibilite': {
                BOX_4G: [
                    {
                        entity_id: '10093',
                        type_id: 'faim_unlimited',
                        sku: '6733',
                        qty: 1,
                        position: '1',
                        rental_fees: 3,
                        locked: '0',
                        exclu_pro: false,
                        banking_offer: false,
                        transfer_offer: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        to_scan: false,
                        price: 33.99,
                        auto_add_front: 'fai-fmd,generic-box-fai',
                        auto_add_back: '6901443179664',
                        technology: 'BOX_4G',
                        gencode: '6733',
                        sim_type: 'default',
                        name: '4G box',
                        produit_prioritaire: '6901443179664',
                        classification: 'medium_xgbox',
                        url_key: '4g-box-6733',
                        short_description: '4G box',
                        fai_category_type: 'offre_gp',
                        included_services:
                            "Internet en 4G\r\nJusqu'à 220 Mbit/s (débit descendant)\r\nJusqu'à 38 Mbit/s (débit montant)\r\n\r\nTV sur smartphone et tablette\r\n+ de 70 chaînes avec l'application B.tv",
                        has_description: false,
                        final_price: 33.99,
                        ecotax: 0,
                        categories: ['faim_unlimited'],
                        upSellsProducts: ['11148', '13809'],
                        medias: [],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        fmd: 19,
                        box: ['6901443179664', '4894461887302', '6972453162250'],
                        crossSellsProducts: ['3526356054230'],
                        is_preorder: false,
                        url: 'https://web-ap3.bouyguestelecom.fr/forfait-internet-mobile-illimite/4g-box-6733',
                        relatedProduct: [],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/6733',
                            },
                            etendu: {
                                href: '/ventes/produits/6733/etendu',
                            },
                        },
                        range: 'medium_xgbox',
                        speed_up: '38 Mb/s',
                        speed_down: '220 Mb/s',
                        convergence: true,
                    },
                ],
                ADSL: [
                    {
                        entity_id: '10940',
                        type_id: 'fai',
                        sku: '72156233',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '0',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 29.99,
                        range: 'small',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        equipment: 'internet',
                        technical_label: 'Bbox Fit VDSL 2P DT 29,99E ENG 12M',
                        unbundling: 'total',
                        play: '2P',
                        technology: 'VDSL',
                        label: 'Bbox fit (VDSL) : Internet - Téléphonie',
                        gencode: '72156233',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                        small_image: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                        image: '/media/catalog/product/b/b/bbox_fit_1_26_1_1_2_2.png',
                        name: 'Bbox Fit (VDSL) : Internet - Téléphonie',
                        url_key: '72156233-engagement',
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'dolmen',
                        short_description: 'Bbox Fit VDSL 2P DT 29,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 29.99,
                        ecotax: 0,
                        categories: ['fai'],
                        upSellsProducts: [
                            '72156439',
                            '72155553',
                            '72154460',
                            '72156162',
                            '72156118',
                            '72156100',
                            '72155688',
                            '72156190',
                            '72154932',
                            '72154731',
                            '72154424',
                            '72155390',
                            '72153256',
                            '72155563',
                            '72151539',
                        ],
                        medias: ['media/catalog/product//b/b/bbox_fit_1_26_1_1_2_2.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930101946',
                            '3770008652965',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '3662515018740',
                            '0889842611564',
                            '3523930102295',
                            '3499550359077',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72156233-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156233',
                            },
                            etendu: {
                                href: '/ventes/produits/72156233/etendu',
                            },
                        },
                        speed_up: '12 Mb/s',
                        speed_down: '70 Mb/s',
                        promotion: {
                            amount: 14,
                            duration: 6,
                            description: 'Remise Bbox Fit',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10946',
                        type_id: 'fai',
                        sku: '72156239',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '0',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 39.99,
                        range: 'medium',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv',
                        technical_label: 'Bbox Must 4K VDSL 3P DT 39,99E ENG 12M',
                        unbundling: 'total',
                        play: '3P',
                        technology: 'VDSL',
                        label: 'Bbox must (VDSL) :  Internet - TV - Téléphonie ',
                        gencode: '72156239',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                        small_image: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                        image: '/media/catalog/product/b/b/bbox_must_dsl_4_20.png',
                        name: 'Bbox Must (VDSL) :  Internet - TV - Téléphonie',
                        url_key: '72156239-engagement',
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'dolmen',
                        short_description: 'Bbox Must 4K VDSL 3P DT 39,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 39.99,
                        ecotax: 0,
                        categories: ['fai'],
                        upSellsProducts: [
                            '72156201',
                            '72156100',
                            '72156118',
                            '72156162',
                            '72155687',
                            '72154460',
                            '72156205',
                            '72156206',
                            '72156439',
                            '72156190',
                            '72155638',
                            '72154931',
                            '72154087',
                            '72154560',
                            '72155924',
                            '72155269',
                            '72154085',
                            '72152176',
                            '72155140',
                            '72155641',
                            '72156186',
                            '72155754',
                            '72154459',
                            '72151539',
                            '72154462',
                            '72155390',
                            '72154115',
                            '72150761',
                            '72153256',
                            '72154082',
                            '72155553',
                            '72154932',
                            '72154731',
                        ],
                        medias: [
                            'media/catalog/product//b/b/bbox_must_2_7_1_1_3.png',
                            'media/catalog/product//b/b/bbox_must_dsl_4_20.png',
                        ],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3499550359077',
                            '3523930104947',
                            '3760274861789',
                            '3770008652965',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '3662515018740',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3523930101946',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap3.bouyguestelecom.fr/offres-internet-elig/72156239-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156239',
                            },
                            etendu: {
                                href: '/ventes/produits/72156239/etendu',
                            },
                        },
                        speed_up: '12 Mb/s',
                        speed_down: '70 Mb/s',
                        promotion: {
                            amount: 16,
                            duration: 6,
                            description: 'Remise Bbox Must',
                        },
                        convergence: true,
                    },
                ],
            },
        },
        mustGetOffers: false,
        eligType: 'search',
        userId: null,
    },
    expiresTimestamp: null,
};

export const MOCK_BANDYOU = {
    data: {
        idPanier: '65ba380862477812777b5ba7',
        techno: 'FTTH',
        address: {
            codePostal: '94260',
            voie: 'ALL GERVAISE',
            commune: 'FRESNES',
            numeroVoie: '8',
            pto: 'FI-2875-2999',
            inlineSplit: ['8  ALL GERVAISE', '94260 FRESNES'],
            inline: '8  ALL GERVAISE 94260 FRESNES',
        },
        technicalAddress: {
            zipCode: '94260',
            city: {
                label: 'FRESNES',
                INSEECode: '94034',
            },
            street: {
                label: 'ALL GERVAISE',
                rivoliCode: '4155',
            },
            streetNumber: {
                number: '8',
                complement: '',
                label: '8',
            },
            hexaKey: '940342233S',
            id: '94034GERAE00031',
            imb: 'IMB/94034/S/01FP',
        },
        results: {
            ftth: {
                offers: [
                    '72156516',
                    '72156532',
                    '72156550',
                    '72155959',
                    '72155938',
                    '72156518',
                    '72156544',
                    '72156536',
                    '72156255',
                    '72156540',
                    '72156279',
                    '72156542',
                    '72155934',
                    '72155383',
                    '72155442',
                    '72156172',
                    '72156257',
                    '72155241',
                    '72156251',
                    '72156242',
                    '72156253',
                    '72156522',
                    '72156170',
                    '72156230',
                    '72156546',
                    '72156188',
                    '72156548',
                    '72155936',
                    '72156249',
                    '72156538',
                    '72155668',
                    '72156259',
                    '72155784',
                    '72155706',
                    '72155920',
                    '72155207',
                    '72155782',
                    '72156221',
                    '72155966',
                    '72156520',
                    '72156235',
                    '72156281',
                    '72156530',
                    '72156534',
                    '72155932',
                    '72155918',
                    '72155223',
                ],
                status: true,
                technoType: 'ftth',
                forecast: {
                    name: 'FTTH_DANS_LA_VILLE',
                    date: '2018-07-09',
                    program: 'FTTH',
                },
                buildings: [
                    {
                        building: '_NA_',
                        stairs: [
                            {
                                stair: '0',
                                stages: [
                                    {
                                        floor: '0',
                                        ptoRequired: false,
                                        ptos: [
                                            {
                                                pto: 'FI-2875-2999',
                                                lineStatus: 'ACTIVE',
                                            },
                                        ],
                                    },
                                ],
                            },
                        ],
                        type: 'PAVILLON',
                        ptoPresenceRate: 'SATISFAISANT',
                    },
                ],
                shouldBypass: true,
                groupeCategorieRaccoLogement: 'PBO_AERIEN',
                housingType: 'PAVILLON',
                pmLocationType: 'PME',
                pto: 'FI-2875-2999',
            },
            xdsl: {
                offers: [],
                status: false,
                technoType: 'xdsl',
            },
            box4g: {
                offers: [],
                status: false,
                technoType: 'box4g',
            },
            box5g: {
                offers: [],
                status: false,
                technoType: 'box5g',
            },
        },
        offers: [
            {
                entity_id: '6595',
                type_id: 'fai',
                sku: '72155207',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                is_highlighted: false,
                exclu_assos: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro + (FTTH) : Internet - TV - Téléphonie ',
                image: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                small_image: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                thumbnail: '/media/catalog/product/v/i/visuel_ultym_2_10_1_1.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155207',
                label: 'Bbox Pro+ (FTTH) :  Internet - TV - Téléphonie',
                technology: 'FTTH',
                play: '3P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 3P ZE 50,99E ENG 12M',
                equipment: 'internet_box_tv_eole',
                support_stockage: 'Enregistreur 128 Go inclus',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155207-engagement-1-1',
                short_description: 'Une offre renforcée avec un Wi-Fi<br> étendu et la TV en 4K',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155268',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_7_2_1_1.png',
                    'media/catalog/product//v/i/visuel_ultym_2_10_1_1.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72155207-engagement-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155207',
                    },
                    etendu: {
                        href: '/ventes/produits/72155207/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '6609',
                type_id: 'fai',
                sku: '72155223',
                qty: 0,
                position: '1',
                priority: '1',
                portability: '2',
                duration_promo: '12',
                rental_fees: 3,
                bonus_fai: '0',
                guaranteed_internet: true,
                exclu_pro: true,
                exclu_assos: false,
                is_highlighted: false,
                to_scan: false,
                price: 50.99,
                additional_wide_area: '0.0000',
                name: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                image: '/media/catalog/product/e/o/eole_vancouver_2.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_2.png',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_2.png',
                obligation: 'monthly12',
                sim_type: 'default',
                gencode: '72155223',
                label: 'Bbox Pro+ (FTTH) : Internet - Téléphonie',
                technology: 'FTTH',
                play: '2P',
                unbundling: 'aucun',
                range: 'large',
                technical_label: 'Bbox Pro+ FTTH 2P ZE 50,99E ENG 12M',
                equipment: 'internet_box_tv_hdr',
                speed_up: '1 Gb/s',
                speed_down: '2 Gb/s',
                auto_add_front: '72155144,generic-box-fai',
                commercial_partner: 'none',
                commercial_range: 'Bbox Pro+',
                url_key: '72155223-engagement-1-1-1',
                short_description: 'Essentiel de la fibre',
                network: 'N/A',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                fai_category_type: 'offre_pro',
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6 dernière génération\r\nRépéteur WIFI 6 inclus sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                has_description: true,
                final_price: 50.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72153256',
                    '72151539',
                    '72155902',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_fit_1_28_2_2_2_1.png',
                    'media/catalog/product//b/t/bt_eole-4k-front_00001_3.png',
                    'media/catalog/product//e/o/eole_vancouver_2.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72155223-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155223',
                    },
                    etendu: {
                        href: '/ventes/produits/72155223/etendu',
                    },
                },
                promotion: {
                    amount: 18,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '9039',
                type_id: 'fai',
                sku: '72155782',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                equipment: 'internet_eole',
                technical_label: 'Bbox Pro Wi-Fi 6 FTTH 2P ZE 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) : Internet - Téléphonie',
                gencode: '72155782',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_28_2_2_1_1.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : : Internet - Téléphonie',
                url_key: '72155782-engagement-1-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Essentiel de la fibre',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154460',
                    '72155390',
                    '72155553',
                    '72156162',
                    '72156439',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_28_2_2_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72155782-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155782',
                    },
                    etendu: {
                        href: '/ventes/produits/72155782/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '9041',
                type_id: 'fai',
                sku: '72155784',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: true,
                guaranteed_internet: true,
                bonus_fai: '0',
                to_scan: false,
                additional_wide_area: '0.0000',
                price: 41.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '1 Gb/s',
                support_stockage: 'Enregistreur 128 Go inclus',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Pro FTTH 3P ZE 41,99E ENG 12M',
                commercial_range: 'Bbox Pro',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Pro (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72155784',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                image: '/media/catalog/product/b/b/bbox_ultym_1_9_1_1_1_1.png',
                name: 'Bbox Pro Wi-Fi 6 (FTTH) : Internet - TV - Téléphonie',
                url_key: '72155784-engagement-1-1-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s (débit descendant)\r\nJusqu'à 1 Gbit/s (débit montant)\r\nWIFI 6\r\nRépéteur WIFI 5 (en option)\r\n\r\nTV sur demande\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nPack Pro inclus\r\nInternet Garanti Pro\r\nIntervention garantie en moins de 8 heures\r\nDébit montant boosté 1Gbits/s\r\nInstallation clé en main\r\nService clients dédié Pro",
                pack_pro:
                    'Internet garanti Pro\r\nIntervention garantie en moins de 8h\r\nDébit montant boosté 1 Gbit/s\r\nInstallation 100% clé en main\r\nService Clients dédié Pro',
                fai_category_type: 'offre_pro',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: false,
                final_price: 41.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156162',
                    '72154460',
                    '72156459',
                    '72156439',
                    '72155390',
                    '72155553',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72154932',
                    '72154731',
                    '72153256',
                    '72151539',
                    '72155268',
                ],
                medias: ['media/catalog/product//b/b/bbox_ultym_1_9_1_1_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72155784-engagement-1-1-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72155784',
                    },
                    etendu: {
                        href: '/ventes/produits/72155784/etendu',
                    },
                },
                promotion: {
                    amount: 15,
                    duration: 12,
                    description: 'Remise',
                },
                convergence: true,
            },
            {
                entity_id: '10937',
                type_id: 'fai',
                sku: '72156230',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'small',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '400 Mb/s',
                speed_up: '400 Mb/s',
                equipment: 'internet',
                technical_label: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M',
                commercial_range: 'Bbox fit',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                gencode: '72156230',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                url_key: '72156230-engagement',
                included_services:
                    "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M\r\n',
                has_description: false,
                final_price: 29.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72156439',
                    '72154460',
                    '72154474',
                    '72156162',
                    '72156118',
                    '72156100',
                    '72156190',
                    '72154932',
                    '72154731',
                    '72154424',
                    '72155390',
                    '72153256',
                    '72155563',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/b/bbox_fit_1_29_1_1_3_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156230-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156230',
                    },
                    etendu: {
                        href: '/ventes/produits/72156230/etendu',
                    },
                },
                promotion: {
                    amount: 14,
                    duration: 6,
                    description: 'Remise Bbox Fit',
                },
                convergence: true,
            },
            {
                entity_id: '10942',
                type_id: 'fai',
                sku: '72156235',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156235',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156235-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_9_1_3_2_1_5.png',
                    'media/catalog/product//b/b/bbox_must_ftth_2_5.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156235-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156235',
                    },
                    etendu: {
                        href: '/ventes/produits/72156235/etendu',
                    },
                },
                promotion: {
                    amount: 16,
                    duration: 6,
                    description: 'Remise Bbox Must',
                },
                convergence: true,
            },
            {
                entity_id: '10926',
                type_id: 'fai',
                sku: '72156242',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox ultym (FTTH) :  Internet - TV - Téléphonie',
                gencode: '72156242',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156242',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M\r\n',
                has_description: true,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156459',
                    '72156439',
                    '72156162',
                    '72154489',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72155638',
                    '72155641',
                    '72155754',
                    '72156190',
                    '72152176',
                    '72155924',
                    '72154731',
                    '72155140',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_4_7.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156242',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156242',
                    },
                    etendu: {
                        href: '/ventes/produits/72156242/etendu',
                    },
                },
                promotion: {
                    amount: 20,
                    duration: 6,
                    description: 'Remise Bbox Ultym',
                },
                convergence: true,
            },
            {
                entity_id: '10928',
                type_id: 'fai',
                sku: '72156249',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'sl_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended_box_tv_hdr',
                technical_label: 'Bbox Ultym Gaming FTTH 3P ZE 49,99E ENG 24M',
                commercial_range: 'Bbox ultym',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156249',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                image: '/media/catalog/product/e/o/eole_vancouver_6_3_3_1.png',
                name: 'Série Spéciale Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156249',
                included_services:
                    "Internet \r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi \r\nWIFI Ultym partout dans la maison \r\nWIFI 6 E dernière génération \r\nInstallation fibre & Bbox 100 % accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WIFI\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France / Europe/Suisse et vers fixes de plus de 110 pays \r\nAppels illimités vers les mobiles en France/Europe/Suisse\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Gaming FTTH 3P ZE 49,99E ENG 24M',
                has_description: false,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156459',
                    '72156439',
                    '72156162',
                    '72154489',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72155638',
                    '72155641',
                    '72155754',
                    '72156190',
                    '72152176',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155924',
                    '72154932',
                    '72155268',
                    '72155390',
                    '72153256',
                    '72154115',
                    '72154082',
                    '72154085',
                    '72154087',
                    '72154560',
                    '72151539',
                    '72150761',
                    '72154459',
                    '72154462',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_6_3_3_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72156249',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156249',
                    },
                    etendu: {
                        href: '/ventes/produits/72156249/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10954',
                type_id: 'fai',
                sku: '72156251',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'sl_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Bbox Must Gaming WIFI 6 FTTH 3P ZE 39,99E ENG 24M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156251',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_1_1.png',
                name: 'Série Spéciale Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156251',
                included_services:
                    "Internet \r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi \r\nDiagnostique Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines \r\nEnregistreur TV 100 heures\r\n\r\nTéléphone fixe \r\nAppels illimités vers fixes et mobiles en France et vers\r\nfixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois ",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Gaming WIFI 6 FTTH 3P ZE 39,99E ENG 24M',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72155754',
                    '72156190',
                    '72155638',
                    '72155641',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//b/b/bbox_must_ftth_2_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72156251',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156251',
                    },
                    etendu: {
                        href: '/ventes/produits/72156251/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10956',
                type_id: 'fai',
                sku: '72156253',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 39.99,
                range: 'bbox_smart_tv',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_eole',
                technical_label: 'Bbox Must Smart TV FTTH 2P ZE 39,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P ZE',
                gencode: '72156253',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                small_image: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                image: '/media/catalog/product/b/b/bbox_must_smart_tv_3.png',
                meta_title: ' ',
                name: 'Bbox Must Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156253-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Must Wi-Fi 6 Smart TV FTTH 2P ZE 39,99E ENG 24M\r\n',
                has_description: false,
                final_price: 39.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72154926',
                    '72156460',
                    '72156439',
                    '72156206',
                    '72156205',
                    '72156201',
                    '72156162',
                    '72156118',
                    '72155553',
                    '72154460',
                    '72155638',
                    '72155641',
                    '72155754',
                    '72156190',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72154115',
                    '72152176',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [
                    'media/catalog/product//b/b/bbox_ultym_1_8_2_2_2_1_1_1_2.png',
                    'media/catalog/product//b/b/bbox_must_smart_tv_3.png',
                ],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72156253-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156253',
                    },
                    etendu: {
                        href: '/ventes/produits/72156253/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10930',
                type_id: 'fai',
                sku: '72156257',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 49.99,
                range: 'bbox_smart_tv_large',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '2 Gbit/s',
                speed_up: '900 Mbit/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_extended',
                technical_label: 'Bbox Ultym Smart TV FTTH 2P ZE 49,99E ENG 24M',
                commercial_range: 'Bbox Smart TV',
                unbundling: 'aucun',
                play: '2P',
                technology: 'FTTH',
                label: 'Bbox ultym Smart TV (FTTH) : Internet - Téléphonie - TV + Smart TV',
                gencode: '72156257',
                sim_type: 'default',
                obligation: 'monthly24',
                thumbnail: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                small_image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                image: '/media/catalog/product/b/t/bt_eole-4k-side_00000_1__3_1_1_1.png',
                name: 'Bbox Ultym Smart TV (FTTH) : Internet - Téléphonie',
                url_key: '72156257',
                included_services:
                    "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Bbox Ultym Smart TV FTTH 2P ZE 49,99E ENG 24M\r\n',
                has_description: true,
                final_price: 49.99,
                ecotax: 0,
                categories: ['fai'],
                upSellsProducts: [
                    '72156460',
                    '72156162',
                    '72156118',
                    '72155901',
                    '72155787',
                    '72155553',
                    '72156190',
                    '72154932',
                    '72155474',
                    '72154731',
                    '72155268',
                    '72155390',
                    '72155925',
                    '72151539',
                ],
                medias: ['media/catalog/product//b/t/bt_eole-4k-side_00000_1__3_1_1_1.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3523930101946',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/72156257',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156257',
                    },
                    etendu: {
                        href: '/ventes/produits/72156257/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10960',
                type_id: 'fai',
                sku: '72156279',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 33.99,
                range: 'ss_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéciale Bbox Must FTTH 3P ZE 33,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156279',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_6.png',
                name: 'Série Spéciale Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156279-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox Must WIFI 6 FTTH 3P ZE 33,99E ENG 12M\r\n',
                has_description: false,
                final_price: 33.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156279-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156279',
                    },
                    etendu: {
                        href: '/ventes/produits/72156279/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '10934',
                type_id: 'fai',
                sku: '72156281',
                qty: 0,
                position: '1',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 26.99,
                range: 'se_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'Série Spéc Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Série Spéciale Bbox Fibre (FTTH) : Internet - TV - Téléphonie',
                gencode: '72156281',
                sim_type: 'default',
                thumbnail: '/media/catalog/product/e/o/eole_vancouver_9.png',
                small_image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                name: 'Série Spéciale Bbox Fibre Exclu B&You (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156281-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG\r\n',
                has_description: true,
                final_price: 26.99,
                ecotax: 0,
                categories: ['fai', 'FAI-SIMO'],
                upSellsProducts: [
                    '72156439',
                    '72156118',
                    '72154926',
                    '72155553',
                    '72156100',
                    '72156162',
                    '72154460',
                    '72156215',
                    '72156201',
                    '72156205',
                    '72156206',
                    '72155638',
                    '72155641',
                    '72155754',
                    '72156190',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72154115',
                    '72152176',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: ['media/catalog/product//e/o/eole_vancouver_9.png'],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156281-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156281',
                    },
                    etendu: {
                        href: '/ventes/produits/72156281/etendu',
                    },
                },
                convergence: false,
            },
            {
                entity_id: '11376',
                type_id: 'fai',
                sku: '72156542',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 28.99,
                range: 'ss_medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'SP Must Mobile WIFI 6 FTTH 3P ZE 28,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156542',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_9_2_2_2_2.png',
                name: 'Série Spéciale Bbox Must Mobile (FTTH) : Internet - TV – Téléphonie',
                url_key: '72156542-engagement',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_gp',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Une offre complète<br> Internet-TV-Téléphonie',
                has_description: true,
                final_price: 28.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72155553',
                    '72154926',
                    '72156118',
                    '72156162',
                    '72156206',
                    '72156201',
                    '72154460',
                    '72156205',
                    '72156459',
                    '72156439',
                    '72155641',
                    '72155638',
                    '72156190',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72154931',
                    '72155268',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72155390',
                    '72154085',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156542-engagement',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156542',
                    },
                    etendu: {
                        href: '/ventes/produits/72156542/etendu',
                    },
                },
                convergence: true,
            },
            {
                entity_id: '11377',
                type_id: 'fai',
                sku: '72156544',
                qty: 0,
                position: '0',
                rental_fees: 3,
                duration_promo: '12',
                portability: '2',
                priority: '1',
                bonus_fai: '0',
                to_scan: false,
                is_highlighted: false,
                exclu_assos: false,
                exclu_pro: false,
                guaranteed_internet: true,
                additional_wide_area: '0.0000',
                price: 29.99,
                range: 'medium',
                commercial_partner: 'none',
                auto_add_front: '72155144,generic-box-fai',
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                equipment: 'internet_box_tv_eole',
                technical_label: 'SP Must Mobile WIFI 6 FTTH 3P ZE 29,99E ENG 12M',
                commercial_range: 'Bbox must',
                unbundling: 'aucun',
                play: '3P',
                technology: 'FTTH',
                label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                gencode: '72156544',
                sim_type: 'default',
                obligation: 'monthly12',
                thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_12.png',
                small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_12.png',
                image: '/media/catalog/product/b/b/bbox_must_ftth_2_12.png',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                url_key: '72156544-engagement-1',
                included_services:
                    "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                fai_category_type: 'offre_old',
                way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                network: 'N/A',
                short_description: 'Série Spéciale Bbox Must Mobile WIFI 6 FTTH 3P ZE 29,99E ENG 12M\r\n',
                has_description: true,
                final_price: 29.99,
                ecotax: 0,
                categories: ['FAI-SS-PREMIUM'],
                upSellsProducts: [
                    '72156459',
                    '72156118',
                    '72155553',
                    '72154926',
                    '72156162',
                    '72156439',
                    '72156206',
                    '72154460',
                    '72156205',
                    '72156201',
                    '72155638',
                    '72155641',
                    '72156190',
                    '72155754',
                    '72155140',
                    '72154731',
                    '72155268',
                    '72154931',
                    '72154932',
                    '72152176',
                    '72154115',
                    '72153256',
                    '72154082',
                    '72154085',
                    '72155390',
                    '72154087',
                    '72154459',
                    '72154462',
                    '72154560',
                    '72151539',
                    '72150761',
                ],
                medias: [],
                in_stock: true,
                max_qty: 1,
                soon_exhausted: false,
                crossSellsProducts: [
                    '3523930105227',
                    '3770008652880',
                    '3770008652613',
                    '3770008652934',
                    '6934177723391',
                    '0889842611564',
                    '3523930102295',
                    '3499550331769',
                    '3523930101069',
                    '3523930103254',
                    '6935364092382',
                    '6934177722264',
                    '0745883643622',
                    '3760274861161',
                    '3760274861215',
                    '0722868434413',
                    '4250059697966',
                    '3523930101946',
                    '3770024338058',
                ],
                is_preorder: false,
                url: 'https://web-ap18.bouyguestelecom.fr/offres-internet-elig/fai-ss-premium-web/72156544-engagement-1',
                relatedProduct: ['72155144'],
                tax: 20,
                _links: {
                    detail: {
                        href: '/ventes/produits/72156544',
                    },
                    etendu: {
                        href: '/ventes/produits/72156544/etendu',
                    },
                },
                convergence: true,
            },
        ],
        offersWithOptions: [],
        ocs: [],
        cache: {
            '/offres-internet/test-eligibilite-bboxbandyou': {
                FTTH: [
                    {
                        entity_id: '10937',
                        type_id: 'fai',
                        sku: '72156230',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 29.99,
                        range: 'small',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '400 Mb/s',
                        speed_up: '400 Mb/s',
                        equipment: 'internet',
                        technical_label: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M',
                        commercial_range: 'Bbox fit',
                        unbundling: 'aucun',
                        play: '2P',
                        technology: 'FTTH',
                        label: 'Bbox fit (FTTH) : Internet - Téléphonie',
                        gencode: '72156230',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        small_image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        image: '/media/catalog/product/b/b/bbox_fit_1_29_1_1_3_1_1.png',
                        name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                        url_key: '72156230-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 400 Mbit/s en téléchargement\r\nJusqu'à 400 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\n \r\nTéléphonie fixe\r\nAppels illimités vers fixes en France et plus de 110 pays",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Fit FTTH 2P ZE 29,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 29.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72156439',
                            '72154460',
                            '72154474',
                            '72156162',
                            '72156118',
                            '72156100',
                            '72156190',
                            '72154932',
                            '72154731',
                            '72154424',
                            '72155390',
                            '72153256',
                            '72155563',
                            '72151539',
                        ],
                        medias: ['media/catalog/product//b/b/bbox_fit_1_29_1_1_3_1_1.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156230-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156230',
                            },
                            etendu: {
                                href: '/ventes/produits/72156230/etendu',
                            },
                        },
                        promotion: {
                            amount: 14,
                            duration: 6,
                            description: 'Remise Bbox Fit',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10942',
                        type_id: 'fai',
                        sku: '72156235',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 39.99,
                        range: 'medium',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '1 Gb/s',
                        speed_up: '700 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv_eole',
                        technical_label: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M',
                        commercial_range: 'Bbox must',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox must WIFI 6 (FTTH) :  Internet - TV - Téléphonie ',
                        gencode: '72156235',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        small_image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        image: '/media/catalog/product/b/b/bbox_must_ftth_2_5.png',
                        name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156235-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Must WIFI 6 FTTH 3P ZE 39,99E ENG 12M\r\n',
                        has_description: false,
                        final_price: 39.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72155553',
                            '72154926',
                            '72156118',
                            '72156162',
                            '72156206',
                            '72156201',
                            '72154460',
                            '72156205',
                            '72156459',
                            '72156439',
                            '72155641',
                            '72155638',
                            '72156190',
                            '72155754',
                            '72155140',
                            '72154731',
                            '72154931',
                            '72155268',
                            '72154932',
                            '72152176',
                            '72154115',
                            '72153256',
                            '72154082',
                            '72155390',
                            '72154085',
                            '72154087',
                            '72154459',
                            '72154462',
                            '72154560',
                            '72151539',
                            '72150761',
                        ],
                        medias: [
                            'media/catalog/product//b/b/bbox_ultym_1_9_1_3_2_1_5.png',
                            'media/catalog/product//b/b/bbox_must_ftth_2_5.png',
                        ],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3523930101946',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156235-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156235',
                            },
                            etendu: {
                                href: '/ventes/produits/72156235/etendu',
                            },
                        },
                        promotion: {
                            amount: 16,
                            duration: 6,
                            description: 'Remise Bbox Must',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10926',
                        type_id: 'fai',
                        sku: '72156242',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 49.99,
                        range: 'large',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '2 Gb/s',
                        speed_up: '900 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_extended_box_tv_hdr',
                        technical_label: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M',
                        commercial_range: 'Bbox ultym',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Bbox ultym (FTTH) :  Internet - TV - Téléphonie',
                        gencode: '72156242',
                        sim_type: 'default',
                        obligation: 'monthly12',
                        thumbnail: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        small_image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        image: '/media/catalog/product/e/o/eole_vancouver_6_4_7.png',
                        name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156242',
                        included_services:
                            "Internet\r\nJusqu'à 2 Gbit/s en téléchargement\r\nJusqu'à 900 Mbit/s en envoi\r\n \r\nWIFI Ultym partout dans la maison\r\nWIFI 6E dernière génération\r\nInstallation fibre & Bbox 100% accompagnée et diagnostic Wifi fait par le technicien\r\nJusqu'à 2 répéteurs inclus selon le diagnostic WiFi\r\nMini box 4G avec 50 Go/mois\r\n\r\nTV\r\nPlus de 180 chaines\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France / Europe / Suisse et vers fixes de plus de 110 pays\r\n\r\nAvantages découverte\r\nDisney+ Standard inclus pendant 6 mois puis 8,99€ / mois\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Bbox Ultym FTTH 3P ZE 49,99E ENG 12M\r\n',
                        has_description: true,
                        final_price: 49.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72156459',
                            '72156439',
                            '72156162',
                            '72154489',
                            '72156118',
                            '72155901',
                            '72155787',
                            '72155553',
                            '72155638',
                            '72155641',
                            '72155754',
                            '72156190',
                            '72152176',
                            '72155924',
                            '72154731',
                            '72155140',
                            '72154931',
                            '72155268',
                            '72154932',
                            '72155390',
                            '72153256',
                            '72154115',
                            '72154082',
                            '72154085',
                            '72154087',
                            '72154560',
                            '72151539',
                            '72150761',
                            '72154459',
                            '72154462',
                        ],
                        medias: ['media/catalog/product//e/o/eole_vancouver_6_4_7.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3523930101946',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156242',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156242',
                            },
                            etendu: {
                                href: '/ventes/produits/72156242/etendu',
                            },
                        },
                        promotion: {
                            amount: 20,
                            duration: 6,
                            description: 'Remise Bbox Ultym',
                        },
                        convergence: true,
                    },
                    {
                        entity_id: '10934',
                        type_id: 'fai',
                        sku: '72156281',
                        qty: 0,
                        position: '1',
                        rental_fees: 3,
                        duration_promo: '12',
                        portability: '2',
                        priority: '1',
                        bonus_fai: '0',
                        to_scan: false,
                        is_highlighted: false,
                        exclu_assos: false,
                        exclu_pro: false,
                        guaranteed_internet: true,
                        additional_wide_area: '0.0000',
                        price: 26.99,
                        range: 'se_medium',
                        commercial_partner: 'none',
                        auto_add_front: '72155144,generic-box-fai',
                        speed_down: '1 Gb/s',
                        speed_up: '700 Mb/s',
                        support_stockage: 'Enregistreur TV 100h (Disque dur numérique)',
                        equipment: 'internet_box_tv_eole',
                        technical_label: 'Série Spéc Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG',
                        commercial_range: 'Bbox must',
                        unbundling: 'aucun',
                        play: '3P',
                        technology: 'FTTH',
                        label: 'Série Spéciale Bbox Fibre (FTTH) : Internet - TV - Téléphonie',
                        gencode: '72156281',
                        sim_type: 'default',
                        thumbnail: '/media/catalog/product/e/o/eole_vancouver_9.png',
                        small_image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                        image: '/media/catalog/product/e/o/eole_vancouver_9.png',
                        name: 'Série Spéciale Bbox Fibre Exclu B&You (FTTH) : Internet - TV - Téléphonie',
                        url_key: '72156281-engagement',
                        included_services:
                            "Internet\r\nJusqu'à 1 Gbit/s en téléchargement\r\nJusqu'à 700 Mbit/s en envoi\r\nDiagnostic Wi-Fi\r\nInstallation fibre et Bbox clé en main\r\nWIFI 6 dernière génération\r\n\r\nTV\r\nPlus de 180 chaines\r\nDécodeur TV Bbox 4K\r\nEnregistreur TV 100 heures\r\n\r\nTéléphonie fixe\r\nAppels illimités vers fixes et mobiles en France et vers fixes de plus de 110 pays\r\n\r\nAvantages\r\nAvec cette Bbox, profitez d'un forfait mobile 5G dès 10,99€/mois\r\n\r\nAvantages découverte\r\nUniversal+ offert pendant 6 mois puis 5,99 euros/mois\r\nAmazon prime offert pendant 6 mois puis 6,99 euros/mois",
                        fai_category_type: 'offre_gp',
                        way: 'ACQUISITION,MIGRATION,DEMENAGEMENT',
                        network: 'N/A',
                        short_description: 'Série Spéciale Bbox WIFI 6 FTTH 3P ZE 26,99E SANS ENG\r\n',
                        has_description: true,
                        final_price: 26.99,
                        ecotax: 0,
                        categories: ['fai', 'FAI-SIMO'],
                        upSellsProducts: [
                            '72156439',
                            '72156118',
                            '72154926',
                            '72155553',
                            '72156100',
                            '72156162',
                            '72154460',
                            '72156215',
                            '72156201',
                            '72156205',
                            '72156206',
                            '72155638',
                            '72155641',
                            '72155754',
                            '72156190',
                            '72155140',
                            '72154731',
                            '72155268',
                            '72154931',
                            '72154932',
                            '72154115',
                            '72152176',
                            '72153256',
                            '72154082',
                            '72155390',
                            '72154085',
                            '72154087',
                            '72154459',
                            '72154462',
                            '72154560',
                            '72151539',
                            '72150761',
                        ],
                        medias: ['media/catalog/product//e/o/eole_vancouver_9.png'],
                        in_stock: true,
                        max_qty: 1,
                        soon_exhausted: false,
                        crossSellsProducts: [
                            '3523930105227',
                            '3770008652880',
                            '3770008652613',
                            '3770008652934',
                            '6934177723391',
                            '0889842611564',
                            '3523930102295',
                            '3499550331769',
                            '3523930101069',
                            '3523930103254',
                            '6935364092382',
                            '6934177722264',
                            '0745883643622',
                            '3760274861161',
                            '3760274861215',
                            '0722868434413',
                            '4250059697966',
                            '3523930101946',
                            '3770024338058',
                        ],
                        is_preorder: false,
                        url: 'https://web-ap18.bouyguestelecom.fr/fai-simo/72156281-engagement',
                        relatedProduct: ['72155144'],
                        tax: 20,
                        _links: {
                            detail: {
                                href: '/ventes/produits/72156281',
                            },
                            etendu: {
                                href: '/ventes/produits/72156281/etendu',
                            },
                        },
                        convergence: false,
                    },
                ],
            },
        },
        mustGetOffers: false,
        eligType: 'search',
        userId: null,
    },
    expiresTimestamp: null,
};

export const PY_MOCK = {
    data: {
        idPanier: '672e82e8c3a6d309188f8be7',
        eligType: 'search',
        address: {
            codePostal: '75020',
            voie: 'RUE DE LA PY',
            commune: 'PARIS 20',
            numeroVoie: '25',
            extension: '',
            inlineSplit: ['25  RUE DE LA PY', '75020 PARIS 20'],
            inline: '25  RUE DE LA PY 75020 PARIS 20',
        },
        technicalAddress: {
            zipCode: '75020',
            city: { label: 'PARIS 20', INSEECode: '75120' },
            street: { label: 'RUE DE LA PY', rivoliCode: '7899' },
            streetNumber: { number: '25', complement: '', label: '25' },
            hexaKey: '7512022EXS',
            id: '75120PY0RY00011',
            imb: 'ID-75120000005K',
        },
        housing: { predecessorName: '*******' },
        offersWithOptions: [
            { idOffer: '72155222', options: ['72155902'] },
            { idOffer: '72156774', options: ['72155901'] },
            { idOffer: '72155705', options: ['72155901'] },
            { idOffer: '72156258', options: ['72155901'] },
            { idOffer: '72156935', options: ['72156844'] },
            { idOffer: '72156551', options: ['72155901'] },
            { idOffer: '72156932', options: ['72156844'] },
            { idOffer: '72156837', options: ['72156844'] },
            { idOffer: '72156930', options: ['72156844'] },
            { idOffer: '72156887', options: ['72156844'] },
            { idOffer: '72156888', options: ['72156844'] },
            { idOffer: '72155206', options: ['72155902'] },
            { idOffer: '72156826', options: ['72156844'] },
            { idOffer: '72156256', options: ['72155901'] },
            { idOffer: '72156248', options: ['72155901'] },
            { idOffer: '72156549', options: ['72155901'] },
            { idOffer: '72156280', options: ['72155901'] },
            { idOffer: '72156835', options: ['72156844'] },
            { idOffer: '72156928', options: ['72156844'] },
            { idOffer: '72156519', options: ['72155901'] },
            { idOffer: '72156241', options: ['72155901'] },
            { idOffer: '72155937', options: ['72155901'] },
            { idOffer: '72156833', options: ['72156844'] },
            { idOffer: '72156897', options: ['72156844'] },
            { idOffer: '72155958', options: ['72155901'] },
            { idOffer: '72156936', options: ['72156844'] },
        ],
        results: {
            ftth: {
                offers: [
                    '72156895',
                    '72156901',
                    '72156938',
                    '72156553',
                    '72155222',
                    '72156541',
                    '72156774',
                    '72156531',
                    '72155705',
                    '72156250',
                    '72156258',
                    '72156252',
                    '72156935',
                    '72156278',
                    '72156551',
                    '72156719',
                    '72156220',
                    '72156676',
                    '72156515',
                    '72156776',
                    '72156820',
                    '72156932',
                    '72156837',
                    '72156234',
                    '72156930',
                    '72156899',
                    '72156887',
                    '72155206',
                    '72156529',
                    '72156824',
                    '72156547',
                    '72156537',
                    '72155931',
                    '72156826',
                    '72155441',
                    '72156790',
                    '72156256',
                    '72156545',
                    '72156903',
                    '72156813',
                    '72155667',
                    '72155935',
                    '72156521',
                    '72156674',
                    '72156248',
                    '72156822',
                    '72156788',
                    '72156706',
                    '72155917',
                    '72156539',
                    '72156549',
                    '72156517',
                    '72156280',
                    '72156835',
                    '72156928',
                    '72156772',
                    '72155965',
                    '72156839',
                    '72155382',
                    '72156254',
                    '72156519',
                    '72156241',
                    '72155937',
                    '72156704',
                    '72156807',
                    '72155919',
                    '72156187',
                    '72156833',
                    '72156533',
                    '72156535',
                    '72156897',
                    '72156940',
                    '72155781',
                    '72155783',
                    '72155958',
                    '72156936',
                    '72156543',
                ],
                status: true,
                technology: 'ftth',
                buildings: [
                    {
                        building: 'BATIMENT-1',
                        stairs: [
                            {
                                stair: 'ESCALIER-07',
                                stages: [
                                    {
                                        floor: 'ETAGE-01',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307210-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307211-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-02',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CT-B259-7519', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1306960-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-03',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307209-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307208-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-04',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1306957-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1306956-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-05',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CT-B211-9525', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307207-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-06',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307205-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307213-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-07',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307212-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307204-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-08',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1306958-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1306959-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-RDC',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307203-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307202-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                ],
                            },
                            {
                                stair: 'ESCALIER-08',
                                stages: [
                                    {
                                        floor: 'ETAGE-01',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307233-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307232-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307234-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-02',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CT-B211-9536', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307219-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307220-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307218-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-03',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307230-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307229-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307231-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-04',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307214-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307215-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-05',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307227-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307226-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-06',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307236-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307235-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307237-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-07',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307224-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307223-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-08',
                                        ptoRequired: false,
                                        ptos: [{ pto: 'CTP-1307217-1', lineStatus: 'ACTIVE' }],
                                    },
                                    {
                                        floor: 'ETAGE-RDC',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307222-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307242-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                ],
                            },
                            {
                                stair: 'ESCALIER-09',
                                stages: [
                                    {
                                        floor: 'ETAGE-01',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307267-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307268-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-02',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307258-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307257-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-03',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307265-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307266-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-04',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307255-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307254-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-05',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CT-B225-5265', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307264-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307263-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-06',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307269-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307270-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-07',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307261-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307262-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-08',
                                        ptoRequired: false,
                                        ptos: [{ pto: 'CTP-1307256-1', lineStatus: 'ACTIVE' }],
                                    },
                                    {
                                        floor: 'ETAGE-RDC',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307259-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307260-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                ],
                            },
                            {
                                stair: 'ESCALIER-10',
                                stages: [
                                    {
                                        floor: 'ETAGE-01',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307251-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307250-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-02',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307241-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307240-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-03',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307248-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307249-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-04',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307239-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1306931-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-05',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307246-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307247-1', lineStatus: 'INACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-06',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307252-1', lineStatus: 'INACTIVE' },
                                            { pto: 'CTP-1307253-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-07',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307245-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307244-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                    {
                                        floor: 'ETAGE-RDC',
                                        ptoRequired: false,
                                        ptos: [
                                            { pto: 'CTP-1307221-1', lineStatus: 'ACTIVE' },
                                            { pto: 'CTP-1307243-1', lineStatus: 'ACTIVE' },
                                        ],
                                    },
                                ],
                            },
                        ],
                        type: 'IMMEUBLE',
                        ptoPresenceRate: 'SATISFAISANT',
                    },
                ],
                shouldBypass: false,
                groupCategoryHousingConnection: 'PBO_INTERIEUR',
                housingType: 'IMMEUBLE',
                connectionPointLocationType: 'PMI',
            },
            xdsl: { offers: [], status: false, technology: 'xdsl' },
            box4g: { offers: [], status: false, technology: 'box4g' },
            box5g: {
                offers: ['6815', '6858', '6658', '6754', '6757', '6700', '6535'],
                status: true,
                technology: 'box5g',
                homeZone: 'HZ2-T75001',
            },
        },
        techno: 'FTTH',
        userId: null,
        mustGetOffers: false,
        offers: [
            {
                type: 'faim_unlimited',
                name: '5G box',
                in_stock: true,
                price: 37.99,
                rental_fees: 3,
                speed_down: '1,1 Gb/s',
                speed_up: '58 Mb/s',
                obligation: 'none',
                technology: 'BOX_5G',
                fai_category_type: 'offre_gp',
                sku: '6700',
                discounts: [],
                categories: ['faim_unlimited', 'fai-26', 'fai-eligibilite', 'fai-pro', 'fai-5gbox'],
                rangeNg: 'xgbox',
                commercialSeries: 'medium_xgbox',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'faim_unlimited',
                name: '5G box avec TV',
                in_stock: true,
                price: 41.99,
                rental_fees: 3,
                speed_down: '1,1 Gb/s',
                speed_up: '58 Mb/s',
                obligation: 'none',
                technology: 'BOX_5G',
                fai_category_type: 'offre_gp',
                sku: '6757',
                discounts: [],
                categories: ['faim_unlimited', 'fai-eligibilite', 'fai-5gbox'],
                rangeNg: 'xgbox',
                commercialSeries: 'medium_tv_xgbox',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'faim_unlimited',
                name: '5G box -26 ans',
                in_stock: true,
                price: 25.99,
                rental_fees: 3,
                speed_down: '1,1 Gb/s',
                speed_up: '58 Mb/s',
                obligation: 'none',
                technology: 'BOX_5G',
                fai_category_type: 'offre_gp',
                sku: '6815',
                discounts: [],
                categories: ['faim_unlimited', 'fai-26', 'fai-eligibilite', 'fai-5gbox'],
                rangeNg: 'xgbox',
                commercialSeries: 'ss_medium_xgbox',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Série Spéciale Bbox Fibre 3P Exclu B&You (FTTH) : Internet - TV - Téléphonie',
                in_stock: true,
                price: 26.99,
                rental_fees: 3,
                speed_down: '1 Gb/s',
                speed_up: '700 Mb/s',
                obligation: 'none',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156674',
                discounts: [],
                categories: ['fai', 'FAI-SIMO', 'fai-eligibilite', 'fai-purebyou', 'fai-byou', 'fai-simo-eligibilite'],
                rangeNg: 'must',
                commercialSeries: 'serie_client_bandyou',
                range: 'se_medium',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Must (FTTH) : Internet - TV - Téléphonie',
                in_stock: true,
                price: 38.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly12',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156813',
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: [
                    'fai',
                    'FAI-SIMO',
                    'family-web',
                    'fai-eligibilite',
                    'fai-box-internet',
                    'fai-simo-eligibilite',
                ],
                rangeNg: 'must',
                commercialSeries: 'standard',
                range: 'medium',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Must Smart TV (FTTH) : Internet - Téléphonie',
                in_stock: true,
                price: 46.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly24',
                technology: 'FTTH',
                play: '2P',
                fai_category_type: 'offre_gp',
                sku: '72156820',
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: ['fai', 'FAI-SIMO', 'fai-smart-tv', 'fai-videoprojecteur', 'fai-smart-monitor'],
                rangeNg: 'must',
                commercialSeries: 'smart_tv',
                range: 'bbox_smart_tv',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Must Gaming (FTTH) : Internet - TV - Téléphonie',
                in_stock: true,
                price: 46.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly24',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156824',
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: ['fai', 'FAI-SIMO', 'fai-gaming'],
                rangeNg: 'must',
                commercialSeries: 'gaming',
                range: 'sl_medium',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox ultym (FTTH) : Internet - TV - Téléphonie',
                in_stock: true,
                price: 46.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly12',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156826',
                option: { speed_down: '8 Gb/s', speed_up: '1 Gb/s', price: 0 },
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: [
                    'fai',
                    'FAI-SIMO',
                    'family-web',
                    'fai-eligibilite',
                    'fai-box-internet',
                    'fai-simo-eligibilite',
                ],
                rangeNg: 'ultym',
                commercialSeries: 'standard',
                range: 'large',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Ultym Smart TV (FTTH) : Internet - Téléphonie',
                in_stock: true,
                price: 54.99,
                rental_fees: 3,
                speed_down: '2 Gbit/s',
                speed_up: '900 Mbit/s',
                obligation: 'monthly24',
                technology: 'FTTH',
                play: '2P',
                fai_category_type: 'offre_gp',
                sku: '72156833',
                option: { speed_down: '8 Gb/s', speed_up: '1 Gb/s', price: 0 },
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: ['fai', 'FAI-SIMO', 'fai-smart-tv', 'fai-videoprojecteur', 'fai-smart-monitor'],
                rangeNg: 'ultym',
                commercialSeries: 'smart_tv',
                range: 'bbox_smart_tv_large',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Ultym Gaming (FTTH) : Internet - TV - Téléphonie',
                in_stock: true,
                price: 54.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly24',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156837',
                option: { speed_down: '8 Gb/s', speed_up: '1 Gb/s', price: 0 },
                discounts: [
                    {
                        type: 'FIX',
                        value: 7,
                        discount: 7,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                        pennant: 'Client B.iG : ce prix reste le même après 12 mois',
                    },
                ],
                categories: ['fai', 'FAI-SIMO', 'fai-gaming'],
                rangeNg: 'ultym',
                commercialSeries: 'gaming',
                range: 'sl_large',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Fit (FTTH) : Internet - Téléphonie',
                in_stock: true,
                price: 29.99,
                rental_fees: 3,
                speed_down: '600 Mb/s',
                speed_up: '600 Mb/s',
                obligation: 'monthly12',
                technology: 'FTTH',
                play: '2P',
                fai_category_type: 'offre_gp',
                sku: '72156839',
                discounts: [
                    {
                        type: 'FIX',
                        value: 13,
                        discount: 13,
                        isIncitation: false,
                        isDiffered: false,
                        duration: 12,
                        marketingTypes: [],
                    },
                ],
                categories: ['fai', 'FAI-SIMO', 'fai-eligibilite', 'fai-box-internet', 'fai-simo-eligibilite'],
                rangeNg: 'fit',
                commercialSeries: 'standard',
                range: 'small',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'B&YOU Pure fibre (FTTH) : Internet',
                in_stock: true,
                price: 20.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'none',
                technology: 'FTTH',
                play: '1P',
                fai_category_type: 'offre_gp',
                sku: '72156887',
                option: { speed_down: '8 Gb/s', speed_up: '1 Gb/s', price: 0 },
                discounts: [],
                categories: ['fai', 'FAI-SIMO', 'fai-eligibilite', 'fai-purebyou', 'fai-byou', 'fai-simo-eligibilite'],
                rangeNg: 'very_fit',
                commercialSeries: 'standard',
                range: 'small',
                isHiddenInFocus: false,
                isHidden: false,
            },
            {
                type: 'fai',
                name: 'Bbox Banque : Internet - TV - Téléphonie',
                in_stock: true,
                price: 31.99,
                rental_fees: 3,
                speed_down: '2 Gb/s',
                speed_up: '900 Mb/s',
                obligation: 'monthly12',
                technology: 'FTTH',
                play: '3P',
                fai_category_type: 'offre_gp',
                sku: '72156903',
                discounts: [],
                categories: ['fai', 'FAI-BANQUE-WEB'],
                rangeNg: 'must',
                commercialSeries: 'banque',
                range: 'ss_medium_banque',
                isHiddenInFocus: false,
                isHidden: false,
            },
        ],
        error: null,
    },
    expiresTimestamp: 2061708256000,
};
